import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, withModifiers as _withModifiers, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cf0bea5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company" }
const _hoisted_2 = { class: "company-header" }
const _hoisted_3 = { class: "company-title" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_7 = { class: "section-bar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Mitarbeiter:innen", -1))
const _hoisted_9 = { class: "section-actions" }
const _hoisted_10 = {
  class: "btn-ghost",
  "data-bs-toggle": "modal",
  "data-bs-target": "#inviteUser"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-hint" }, " Legen Sie hier Ihre Mitarbeiter:innen an und weisen Sie ihnen Kurse und Unterweisungen zu. Beim Anlegen erhält jede:r Mitarbeiter:in eine Einladung per E-Mail mit dem Zugang zur Plattform (im Anlegen-Dialog abwählbar). Zusätzlich erinnert die Plattform per E-Mail an einzelne Aufgaben, sobald deren Erinnerungsphase beginnt. Frist und Erinnerungen legen Sie beim Zuweisen der Aufgabe fest. ", -1))
const _hoisted_12 = { class: "table-wrap" }
const _hoisted_13 = { class: "data-table" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Vorname", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nachname", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "E-Mail", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Gruppen", -1))
const _hoisted_18 = { class: "th-help" }
const _hoisted_19 = { class: "th-tip" }
const _hoisted_20 = {
  type: "button",
  class: "th-tip-trigger",
  "aria-label": "Hinweis zu den Aufgaben"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "th-tip-bubble",
  role: "tooltip"
}, " Alle Aufgaben dieses Mitarbeiters: direkt zugewiesene Kurse und Unterweisungen sowie Aufgaben aus Gruppen, in denen er Mitglied ist. ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Aktionen", -1))
const _hoisted_23 = { class: "user-name" }
const _hoisted_24 = {
  key: 0,
  class: "badge badge-owner"
}
const _hoisted_25 = { class: "user-name" }
const _hoisted_26 = { class: "user-email" }
const _hoisted_27 = { class: "user-group-chips" }
const _hoisted_28 = ["title", "onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chip-x" }, "×", -1))
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "assignment-chips assignment-chips--row" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "text-end" }
const _hoisted_35 = { style: {"display":"inline-flex","gap":"4px"} }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "empty-state"
}, "Noch keine Mitarbeiter angelegt.", -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "empty-state"
}, "Keine Mitarbeiter gefunden.", -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_45 = { class: "section-bar" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Gruppen", -1))
const _hoisted_47 = { class: "section-actions" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-hint" }, " Legen Sie hier Gruppen an, um Ihre Mitarbeiter:innen zu strukturieren, zum Beispiel nach Qualifikation, Wohnbereich oder Einsatzort. Aufgaben können Sie einzelnen Mitarbeiter:innen oder ganzen Gruppen zuweisen. Wer einer Gruppe beitritt, übernimmt automatisch deren Aufgaben. ", -1))
const _hoisted_49 = { class: "group-tree" }
const _hoisted_50 = {
  key: 0,
  class: "empty-state",
  style: {"padding":"32px 0"}
}
const _hoisted_51 = {
  key: 1,
  class: "group-drag-error"
}
const _hoisted_52 = { class: "group-card" }
const _hoisted_53 = {
  class: "group-row",
  title: "Zum Sortieren ziehen"
}
const _hoisted_54 = ["title", "aria-expanded", "onClick"]
const _hoisted_55 = {
  key: 1,
  class: "group-collapse-spacer",
  "aria-hidden": "true"
}
const _hoisted_56 = { class: "group-info" }
const _hoisted_57 = { class: "group-name" }
const _hoisted_58 = { class: "group-chip-row" }
const _hoisted_59 = { class: "group-course-chips" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "group-member-chips" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "group-actions" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "group-child-item" }
const _hoisted_67 = {
  class: "group-row child-row",
  title: "Zum Sortieren ziehen"
}
const _hoisted_68 = ["title", "aria-expanded", "onClick"]
const _hoisted_69 = {
  key: 1,
  class: "group-collapse-spacer",
  "aria-hidden": "true"
}
const _hoisted_70 = { class: "group-info" }
const _hoisted_71 = { class: "group-name" }
const _hoisted_72 = { class: "group-chip-row" }
const _hoisted_73 = { class: "group-course-chips" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { class: "group-member-chips" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "group-actions" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "group-child-item" }
const _hoisted_81 = {
  class: "group-row child-row",
  title: "Zum Sortieren ziehen"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "group-collapse-spacer",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_83 = { class: "group-info" }
const _hoisted_84 = { class: "group-name" }
const _hoisted_85 = { class: "group-chip-row" }
const _hoisted_86 = { class: "group-course-chips" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "group-member-chips" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "group-actions" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { class: "group-modal" }
const _hoisted_94 = { class: "group-modal-title" }
const _hoisted_95 = ["onKeyup"]
const _hoisted_96 = {
  key: 0,
  class: "group-weight-field"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "group-weight-label" }, "Sortierung (Gewicht)", -1))
const _hoisted_98 = ["onKeyup"]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "group-weight-hint" }, "Kleinere Werte stehen weiter oben. Die Reihenfolge lässt sich auch per Ziehen ändern.", -1))
const _hoisted_100 = {
  key: 1,
  class: "group-modal-error"
}
const _hoisted_101 = { class: "group-modal-footer" }
const _hoisted_102 = ["disabled"]
const _hoisted_103 = ["onClick"]
const _hoisted_104 = { class: "group-modal assign-modal" }
const _hoisted_105 = { class: "group-modal-header" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-modal-title" }, "Mitarbeiter zuordnen", -1))
const _hoisted_107 = { class: "assign-modal-group-name" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "assign-modal-hint" }, "Änderungen werden sofort gespeichert.", -1))
const _hoisted_109 = { class: "assign-user-list" }
const _hoisted_110 = {
  key: 0,
  class: "assign-loading"
}
const _hoisted_111 = ["checked", "onChange"]
const _hoisted_112 = { class: "assign-user-info" }
const _hoisted_113 = { class: "assign-user-name" }
const _hoisted_114 = {
  key: 0,
  class: "assign-user-email"
}
const _hoisted_115 = {
  key: 0,
  class: "assign-empty"
}
const _hoisted_116 = {
  key: 2,
  class: "tab-content"
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-bar" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Freigegebene Kurse")
], -1))
const _hoisted_118 = {
  key: 0,
  class: "empty-state",
  style: {"padding":"48px 0"}
}
const _hoisted_119 = {
  key: 1,
  class: "table-wrap"
}
const _hoisted_120 = { class: "data-table" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Titel"),
    /*#__PURE__*/_createElementVNode("th", null, "Kategorie"),
    /*#__PURE__*/_createElementVNode("th", null, "Dauer"),
    /*#__PURE__*/_createElementVNode("th", null, "Zuweisungen"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Aktionen")
  ])
], -1))
const _hoisted_122 = { class: "user-name" }
const _hoisted_123 = {
  key: 0,
  class: "user-email"
}
const _hoisted_124 = {
  key: 0,
  class: "badge badge-member"
}
const _hoisted_125 = {
  key: 1,
  class: "badge badge-member"
}
const _hoisted_126 = { class: "assignment-chips" }
const _hoisted_127 = ["onClick"]
const _hoisted_128 = {
  key: 1,
  class: "muted-text"
}
const _hoisted_129 = { class: "text-end" }
const _hoisted_130 = ["onClick"]
const _hoisted_131 = { key: 0 }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "empty-state"
}, "Für diese Einrichtung sind noch keine Kurse freigegeben.", -1))
const _hoisted_133 = [
  _hoisted_132
]
const _hoisted_134 = { class: "group-modal list-popup" }
const _hoisted_135 = { class: "group-modal-title" }
const _hoisted_136 = { class: "list-popup-items" }
const _hoisted_137 = ["onClick"]
const _hoisted_138 = { class: "lp-text" }
const _hoisted_139 = { class: "lp-label" }
const _hoisted_140 = {
  key: 0,
  class: "lp-sub"
}
const _hoisted_141 = ["onClick"]
const _hoisted_142 = ["onClick"]
const _hoisted_143 = {
  key: 0,
  class: "lp-empty"
}
const _hoisted_144 = { class: "group-modal-footer" }
const _hoisted_145 = { class: "group-modal" }
const _hoisted_146 = { class: "group-modal-title" }
const _hoisted_147 = { class: "assign-modal-hint" }
const _hoisted_148 = { class: "field-block" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "field-label",
  for: "mark-completed-date"
}, [
  /*#__PURE__*/_createTextVNode("Abschlussdatum "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-hint" }, "Datum, an dem die Fortbildung absolviert wurde.", -1))
const _hoisted_151 = {
  key: 0,
  class: "group-modal-error",
  role: "alert"
}
const _hoisted_152 = { class: "group-modal-footer" }
const _hoisted_153 = ["disabled"]
const _hoisted_154 = { class: "group-modal user-group-modal" }
const _hoisted_155 = { class: "group-modal-title" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "assign-modal-hint" }, "Änderungen werden sofort gespeichert.", -1))
const _hoisted_157 = { class: "group-modal-footer" }
const _hoisted_158 = { class: "group-modal assignment-modal" }
const _hoisted_159 = { class: "group-modal-title" }
const _hoisted_160 = {
  key: 0,
  class: "field-block"
}
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Art", -1))
const _hoisted_162 = { class: "toggle-group" }
const _hoisted_163 = {
  key: 0,
  class: "field-block"
}
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, [
  /*#__PURE__*/_createTextVNode("Unterweisungen "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_165 = { class: "field-hint" }
const _hoisted_166 = {
  key: 1,
  class: "assign-modal-subtitle"
}
const _hoisted_167 = {
  key: 0,
  class: "field-block"
}
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, [
  /*#__PURE__*/_createTextVNode("Kurse "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_169 = { class: "field-hint" }
const _hoisted_170 = {
  key: 1,
  class: "field-block"
}
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, [
  /*#__PURE__*/_createTextVNode("Kurs "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Bitte wählen…", -1))
const _hoisted_173 = ["value"]
const _hoisted_174 = {
  key: 2,
  class: "assign-modal-subtitle"
}
const _hoisted_175 = { class: "field-block" }
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Zuweisen an", -1))
const _hoisted_177 = { class: "toggle-group" }
const _hoisted_178 = { class: "field-block" }
const _hoisted_179 = { class: "field-label" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*", -1))
const _hoisted_181 = { class: "field-hint" }
const _hoisted_182 = { class: "field-block" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Frist (optional)", -1))
const _hoisted_184 = { class: "field-block field-inline" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Jährlich wiederholen", -1))
const _hoisted_186 = { class: "field-block" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Start der Erinnerungsphase", -1))
const _hoisted_188 = { class: "notify-input-row" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notify-unit" }, "Tage vor Frist", -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-hint" }, "Ab wann beginnt die Erinnerungsphase.", -1))
const _hoisted_191 = { class: "field-block" }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Anzahl Erinnerungen", -1))
const _hoisted_193 = { class: "notify-input-row" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-hint" }, "Wie oft wird innerhalb der Phase erinnert (gleichmäßig verteilt bis zur Frist).", -1))
const _hoisted_195 = {
  key: 4,
  class: "group-modal-error"
}
const _hoisted_196 = { class: "group-modal-footer" }
const _hoisted_197 = ["disabled"]
const _hoisted_198 = {
  key: 7,
  class: "tab-content"
}
const _hoisted_199 = {
  key: 8,
  class: "tab-content"
}
const _hoisted_200 = { class: "section-bar" }
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Abschlüsse", -1))
const _hoisted_202 = { class: "section-actions" }
const _hoisted_203 = { class: "table-wrap" }
const _hoisted_204 = { class: "data-table" }
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Mitarbeiter:in"),
    /*#__PURE__*/_createElementVNode("th", null, "Kurse"),
    /*#__PURE__*/_createElementVNode("th", null, "Unterweisungen"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Zertifikat")
  ])
], -1))
const _hoisted_206 = { class: "user-name" }
const _hoisted_207 = { class: "user-email" }
const _hoisted_208 = ["onClick"]
const _hoisted_209 = {
  key: 1,
  class: "muted-text"
}
const _hoisted_210 = ["onClick"]
const _hoisted_211 = {
  key: 1,
  class: "muted-text"
}
const _hoisted_212 = { class: "text-end" }
const _hoisted_213 = ["disabled", "onClick"]
const _hoisted_214 = { key: 0 }
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "empty-state"
}, "Keine Daten vorhanden.", -1))
const _hoisted_216 = [
  _hoisted_215
]
const _hoisted_217 = {
  key: 9,
  class: "tab-content"
}
const _hoisted_218 = { class: "section-bar" }
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Erinnerungen", -1))
const _hoisted_220 = { class: "section-actions" }
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ALL" }, "Alle Status", -1))
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "QUEUED" }, "Übermittelt", -1))
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "DELIVERED" }, "Zugestellt", -1))
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "FAILED" }, "Fehlgeschlagen", -1))
const _hoisted_225 = [
  _hoisted_221,
  _hoisted_222,
  _hoisted_223,
  _hoisted_224
]
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "reminder-hint" }, " Übersicht aller automatisch versendeten Erinnerungen an Mitarbeitende mit offenen Pflicht-Fortbildungen oder Unterweisungen: wann und an wen sie verschickt wurden. ", -1))
const _hoisted_227 = { class: "table-wrap table-scroll" }
const _hoisted_228 = { class: "data-table" }
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Übermittelt am"),
    /*#__PURE__*/_createElementVNode("th", null, "Empfänger:in"),
    /*#__PURE__*/_createElementVNode("th", null, "Art"),
    /*#__PURE__*/_createElementVNode("th", null, "Kurs / Unterweisung"),
    /*#__PURE__*/_createElementVNode("th", null, "Frist"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1))
const _hoisted_230 = { class: "user-name" }
const _hoisted_231 = { class: "user-email" }
const _hoisted_232 = { key: 0 }
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "empty-state"
}, "Wird geladen…", -1))
const _hoisted_234 = [
  _hoisted_233
]
const _hoisted_235 = { key: 1 }
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "empty-state"
}, "Es wurden noch keine Erinnerungen versendet.", -1))
const _hoisted_237 = [
  _hoisted_236
]
const _hoisted_238 = {
  key: 10,
  class: "tab-content"
}
const _hoisted_239 = ["onSubmit"]
const _hoisted_240 = { class: "settings-grid" }
const _hoisted_241 = { class: "settings-card full" }
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Name der Einrichtung", -1))
const _hoisted_243 = { class: "settings-card" }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Straße", -1))
const _hoisted_245 = { class: "settings-card" }
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Hausnummer", -1))
const _hoisted_247 = { class: "settings-card" }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Adresszusatz", -1))
const _hoisted_249 = { class: "settings-card" }
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Postleitzahl", -1))
const _hoisted_251 = { class: "settings-card" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Stadt", -1))
const _hoisted_253 = { class: "settings-card full" }
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Logo", -1))
const _hoisted_255 = { class: "logo-upload-area" }
const _hoisted_256 = { class: "logo-preview-wrap" }
const _hoisted_257 = ["src"]
const _hoisted_258 = {
  key: 1,
  class: "logo-placeholder"
}
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "28",
  height: "28",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8.5",
    cy: "8.5",
    r: "1.5"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "21 15 16 10 5 21" })
], -1))
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Kein Logo", -1))
const _hoisted_261 = [
  _hoisted_259,
  _hoisted_260
]
const _hoisted_262 = { class: "logo-upload-meta" }
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "logo-hint" }, "PNG, JPG oder SVG · Empfohlen: mind. 200 × 200 px", -1))
const _hoisted_264 = ["disabled"]
const _hoisted_265 = {
  key: 0,
  class: "logo-error"
}
const _hoisted_266 = { class: "settings-footer" }
const _hoisted_267 = {
  key: 0,
  class: "save-confirm"
}
const _hoisted_268 = ["disabled"]
const _hoisted_269 = { class: "group-modal edit-user-modal" }
const _hoisted_270 = { class: "group-modal-header" }
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-modal-title" }, "Mitarbeiter bearbeiten", -1))
const _hoisted_272 = { class: "edit-user-grid" }
const _hoisted_273 = { class: "field-block" }
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Vorname", -1))
const _hoisted_275 = ["onKeyup"]
const _hoisted_276 = { class: "field-block" }
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Nachname", -1))
const _hoisted_278 = ["onKeyup"]
const _hoisted_279 = { class: "field-block edit-email-field" }
const _hoisted_280 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "E-Mail-Adresse", -1))
const _hoisted_281 = ["onKeyup"]
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-hint" }, "Die E-Mail-Adresse wird auch für die Anmeldung verwendet.", -1))
const _hoisted_283 = {
  key: 0,
  class: "field-block edit-admin-field"
}
const _hoisted_284 = { class: "edit-admin-label" }
const _hoisted_285 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "edit-admin-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "edit-admin-title" }, "Administrator"),
  /*#__PURE__*/_createElementVNode("span", { class: "edit-admin-hint" }, "Kann Mitarbeiter verwalten, Kurse zuweisen und Einstellungen ändern.")
], -1))
const _hoisted_286 = {
  key: 0,
  class: "group-modal-error"
}
const _hoisted_287 = { class: "group-modal-footer" }
const _hoisted_288 = ["disabled"]
const _hoisted_289 = { class: "group-modal" }
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-modal-title" }, "Aus Gruppe entfernen?", -1))
const _hoisted_291 = { class: "confirm-text" }
const _hoisted_292 = { class: "group-modal-footer" }

import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from '@/store';
import {
  CheckCircleIcon,
  UserPlusIcon,
  TrashIcon,
  PlusIcon,
  Edit2Icon,
  XIcon,
  InfoIcon,
  BookOpenIcon,
  ChevronDownIcon,
} from '@zhuowenli/vue-feather-icons';
import draggable from 'vuedraggable';
import InviteUser from './modal/InviteUser.vue';
import DeleteUser from './modal/DeleteUser.vue';
import InstructionAdmin from '@/components/InstructionAdmin.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import { getAllByOrganisation, completeForUser } from '@training24/course/src/activity';
import { index as getProfiles } from '@training24/user/src/profilePermissions';
import { adminUpdateProfile } from '@training24/user/src/admin';
import { uploadLogo } from '@training24/organisation/src/logo';
import {
  getGroups,
  createGroup,
  updateGroup as updateGroupApi,
  deleteGroup,
  addUserToGroup,
  removeUserFromGroup,
  type Group,
} from '@training24/organisation/src/group';
import { update as updatePermission } from '@training24/organisation/src/permission';
import { displayPDFByUser } from '../utils/getPDFByUser';
import { displayPDFByOrg } from '../utils/getPDFByOrg';
import { printCertificate, printOrgOverview, type CertItem } from '../utils/printCertificate';

type ListPopupEntry = { label: string; sub?: string; onClick?: () => void; onRemove?: () => void; action?: { label: string; onClick: () => void } };
type ListPopupAdd = { label: string; action: () => void } | null;
type GroupNode = Group & { weight?: number };

export default /*#__PURE__*/_defineComponent({
  __name: 'Company',
  setup(__props) {

const store = useStore();

// ── Initial-Loads reaktiv starten, sobald die OrgId verfügbar ist ──
// Nach einem Full-Reload direkt auf /#/company (Org-Wechsel als Admin) mountet
// die Seite, bevor der Organisation-Store die OrgId gesetzt hat (getUserDate →
// organisation/LOAD laufen ohne await im Router-Guard). onMounted allein lädt
// dann ins Leere: leere Profile (Namens-Fallback), keine Gruppen/Aktivitäten.
// Deshalb laufen ALLE Initial-Loads über diesen watch — einmal pro Organisation.
const currentOrgId = computed(() => store.getters['organisation/getOrganisationId']);
let loadedOrgId: string | null = null;
async function initLoads(orgId: string) {
  if (loadedOrgId === orgId) return;
  loadedOrgId = orgId;
  store.dispatch('lmsCourse/LOAD_CATALOG');
  store.dispatch('courseAssignment/LOAD_ALL', orgId);
  await Promise.all([
    load(),
    loadProfiles(),
    loadGroups(),
    loadInstructionCompletions(), // enthält instruction/LOAD_ALL (force)
  ]);
  await loadGroupMemberships();
}
watch(currentOrgId, (orgId) => { if (orgId) initLoads(orgId); });

// ── Tabs ──────────────────────────────────────────────────
const isAdmin = computed<boolean>(() => store.getters['permission/isAdmin']);

// Der Erinnerungs-Reiter ist nur für die Verwaltung (OWNER/ADMIN) sichtbar.
const tabs = computed(() => {
  const list = [
    { id: 'users',        label: 'Mitarbeiter' },
    { id: 'groups',       label: 'Gruppen' },
    { id: 'catalog',      label: 'Kurse' },
    { id: 'instructions', label: 'Unterweisungen' },
    { id: 'courses',      label: 'Aktivitäten' },
  ];
  if (isAdmin.value) list.push({ id: 'reminders', label: 'Erinnerungen' });
  list.push({ id: 'settings', label: 'Einstellungen' });
  return list;
});
const activeTab = ref<string>('users');

// Erinnerungs-Log erst beim Öffnen des Reiters laden.
watch(activeTab, (tab) => {
  if (tab === 'reminders') {
    const orgId = store.getters['organisation/getOrganisationId'];
    if (orgId) store.dispatch('reminderLog/LOAD_ALL', { orgId });
  }
});

// ── Erinnerungen (Admin-Log) ──────────────────────────────
const reminderSearch = ref('');
const reminderStatusFilter = ref<'ALL' | 'QUEUED' | 'DELIVERED' | 'FAILED'>('ALL');
const reminderLogs = computed<any[]>(() => store.getters['reminderLog/getAll']);
const reminderLogsLoading = computed<boolean>(() => store.getters['reminderLog/isLoading']);

const filteredReminderLogs = computed<any[]>(() => {
  const q = reminderSearch.value.trim().toLowerCase();
  return reminderLogs.value.filter((r: any) => {
    if (reminderStatusFilter.value !== 'ALL' && normReminderStatus(r.status) !== reminderStatusFilter.value) return false;
    if (!q) return true;
    return [r.userName, r.email, r.itemTitle].some((v: string) => (v || '').toLowerCase().includes(q));
  });
});

function fmtDateTime(ts: number): string {
  if (!ts) return '';
  const d = new Date(ts);
  return d.toLocaleDateString('de-DE') + ' ' + d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
}
function fmtIsoDate(iso: string): string {
  if (!iso) return '';
  const p = iso.split('-');
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : iso;
}
function reminderKindLabel(kind: string): string {
  return kind === 'INSTRUCTION' ? 'Unterweisung' : 'Kurs';
}
// Alt-Status 'SENT' (vor der Closed-Loop-Bestätigung) wie 'DELIVERED' behandeln.
function normReminderStatus(status: string): string {
  return status === 'SENT' ? 'DELIVERED' : status;
}
function reminderStatusLabel(status: string): string {
  if (status === 'FAILED') return 'Fehlgeschlagen';
  if (status === 'QUEUED') return 'Übermittelt';
  return 'Zugestellt';
}
function reminderBadgeClass(status: string): string {
  if (status === 'FAILED') return 'badge-danger';
  if (status === 'QUEUED') return 'badge-pending';
  return 'badge-success';
}

// ── Store ─────────────────────────────────────────────────
const organisation = computed(() => store.getters['organisation/getOrganisation']);
const users = computed(() => store.getters['permission/getPermissions']);

// ── Mitarbeiter ───────────────────────────────────────────
const selectedUserUserId = ref('');

// Edit user modal
const editUserModalVisible = ref(false);
const editUserTarget = ref<any>(null);
const editUserForm = ref({ firstName: '', lastName: '', email: '', isAdmin: false });
const editUserSaving = ref(false);
const editUserError = ref('');

function openEditUser(user: any) {
  const profile = profiles.value.find((p: any) => p.userId === user.userId);
  editUserForm.value = {
    firstName: profile?.data?.first_name ?? '',
    lastName: profile?.data?.last_name ?? '',
    email: user.email ?? '',
    isAdmin: user.type === 'ADMIN',
  };
  editUserTarget.value = user;
  editUserError.value = '';
  editUserModalVisible.value = true;
}

async function saveEditUser() {
  if (!editUserForm.value.firstName || !editUserForm.value.lastName) {
    editUserError.value = 'Bitte Vor- und Nachname angeben.';
    return;
  }
  const newEmail = editUserForm.value.email.trim();
  if (!newEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail)) {
    editUserError.value = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
    return;
  }
  editUserSaving.value = true;
  editUserError.value = '';
  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    const jwt = store.getters.getJWT;

    await adminUpdateProfile(orgId, editUserTarget.value.userId, {
      first_name: editUserForm.value.firstName,
      last_name: editUserForm.value.lastName,
    }, jwt);

    // Rolle und E-Mail über den Permission-Endpunkt aktualisieren
    const newType = editUserTarget.value.type === 'OWNER'
      ? editUserTarget.value.type
      : (editUserForm.value.isAdmin ? 'ADMIN' : 'VIEWER');
    const roleChanged = newType !== editUserTarget.value.type;
    const emailChanged = newEmail !== (editUserTarget.value.email ?? '');
    if (roleChanged || emailChanged) {
      const payload: any = { type: newType };
      if (emailChanged) payload.email = newEmail;
      await updatePermission(orgId, editUserTarget.value.userId, payload, jwt);
      store.dispatch('permission/LOAD');
    }

    // Profil-Cache aktualisieren
    const idx = profiles.value.findIndex((p: any) => p.userId === editUserTarget.value.userId);
    if (idx >= 0) {
      profiles.value[idx] = {
        ...profiles.value[idx],
        data: { ...profiles.value[idx].data, first_name: editUserForm.value.firstName, last_name: editUserForm.value.lastName },
      };
    }
    editUserModalVisible.value = false;
  } catch (e: any) {
    if (e?.response?.status === 409 && e?.response?.data?.['error-message'] === 'email already in use') {
      editUserError.value = 'Diese E-Mail-Adresse wird bereits verwendet.';
    } else if (e?.response?.status === 409) {
      editUserError.value = 'Dieser Mitarbeiter gehört mehreren Einrichtungen an und kann hier nicht geändert werden.';
    } else {
      editUserError.value = e?.response?.data?.['error-message'] ?? 'Ein Fehler ist aufgetreten.';
    }
  } finally {
    editUserSaving.value = false;
  }
}
const profiles = ref<any[]>([]);

function displayName(user: any): string {
  const profile = profiles.value.find((p: any) => p.userId === user.userId);
  if (profile?.data?.first_name) {
    return `${profile.data.first_name} ${profile.data.last_name}`;
  }
  return user.userName || user.email || '';
}

function userFirstName(user: any): string {
  const profile = profiles.value.find((p: any) => p.userId === user.userId);
  // Ohne Profil-Daten den Benutzernamen als Anhaltspunkt zeigen
  return profile?.data?.first_name || user.userName || '';
}

function userLastName(user: any): string {
  const profile = profiles.value.find((p: any) => p.userId === user.userId);
  return profile?.data?.last_name || '';
}

// ── Suche in der Mitarbeiter-Tabelle ──────────────────────
const userSearch = ref('');

const filteredUsers = computed<any[]>(() => {
  const q = userSearch.value.trim().toLowerCase();
  if (!q) return users.value;
  return (users.value as any[]).filter((u: any) =>
    [userFirstName(u), userLastName(u), u.email || '', u.userName || '']
      .some((v: string) => v.toLowerCase().includes(q))
  );
});

async function loadProfiles() {
  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    if (orgId) {
      profiles.value = await getProfiles(orgId, store.getters.getJWT);
    }
  } catch {
    // optional — bei Fehler ohne Profile anzeigen
  }
}

// ── Kurskatalog (freigegebene Kurse) ──────────────────────
const catalogLoading = ref(false);
const catalogCourses = computed(() => store.getters['lmsCourse/getModules']);

// ── Kurszuweisungen ────────────────────────────────────────
const courseAssignModalVisible = ref(false);
const courseAssignModalCourse = ref<any>(null);   // set when opening from catalog tab; null when from group/user tab
const courseAssignModalMode = ref<'create' | 'edit'>('create');
const courseAssignTargetFixed = ref(false);  // true = target (group/user) is pre-selected, hide toggle+dropdown
const editingAssignment = ref<any>(null);
const courseAssignForm = ref({
  kind: 'course' as 'course' | 'instruction',  // Kurs oder Unterweisung
  instructionId: '',                           // used when kind === 'instruction' (edit mode)
  instructionIds: [] as string[],              // Mehrfachauswahl beim Anlegen
  courseId: '',                               // used when opening from group/user tab (edit mode)
  courseIds: [] as string[],                  // Mehrfachauswahl beim Anlegen
  targetType: 'GROUP' as 'GROUP' | 'USER',
  targetId: '',
  targetIds: [] as string[],   // Mehrfachauswahl beim Anlegen (wenn Ziel nicht vorgewählt)
  deadline: '',
  recurAnnually: false,
  notifyDaysBefore: null as number | null,
  notifyCount: null as number | null,
});

// Alle Unterweisungen (für Dropdown + Titel-Auflösung)
const allInstructions = computed<any[]>(() => store.getters['instruction/getAll'] || []);

function instructionTitle(instructionId: string): string {
  const ins = allInstructions.value.find((i: any) => i.instructionId === instructionId);
  return ins ? ins.title : '';
}

// Kurs-Zuweisungen eines Ziels (kind !== INSTRUCTION; fehlendes kind = Kurs)
function getCourseAssignmentsForTarget(targetType: string, targetId: string): any[] {
  return getAssignmentsForTarget(targetType, targetId).filter((a: any) => a.kind !== 'INSTRUCTION');
}

// Unterweisungs-Zuweisungen eines Ziels (kind === INSTRUCTION)
function getInstructionAssignmentsForTarget(targetType: string, targetId: string): any[] {
  return getAssignmentsForTarget(targetType, targetId).filter((a: any) => a.kind === 'INSTRUCTION');
}

// Chip-Label einer Unterweisungs-Zuweisung
function instructionAssignmentChipLabel(a: any): string {
  const title = instructionTitle(a.instructionId);
  return a.deadline
    ? title + ' (bis ' + new Date(a.deadline).toLocaleDateString('de-DE') + ')'
    : title;
}

// Anzahl aller Zuweisungen (Kurs + Unterweisung) eines Ziels
function assignmentCountForTarget(targetType: string, targetId: string): number {
  return getCourseAssignmentsForTarget(targetType, targetId).length
    + getInstructionAssignmentsForTarget(targetType, targetId).length;
}

// Alle Aufgaben eines Mitarbeiters: direkt zugewiesene plus Aufgaben aus seinen Gruppen
function userTaskCount(user: any): number {
  let count = assignmentCountForTarget('USER', user.userId);
  for (const groupId of (userGroupMemberships.value[user.userId] ?? [])) {
    count += assignmentCountForTarget('GROUP', groupId);
  }
  return count;
}

// ── Listen-Popup (Anzahl-Chip -> Liste) ───────────────────
const listPopup = ref<{ visible: boolean; title: string; entries: ListPopupEntry[]; onAdd: ListPopupAdd }>({
  visible: false,
  title: '',
  entries: [],
  onAdd: null,
});
function openListPopup(title: string, entries: ListPopupEntry[], onAdd: ListPopupAdd = null) {
  listPopup.value = { visible: true, title, entries, onAdd };
}
function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString('de-DE');
}

// Zuweisungen (Kurse + Unterweisungen) eines Ziels als Liste mit Hinzufügen/Entfernen
function openAssignmentsPopup(targetType: 'GROUP' | 'USER', targetId: string, label: string) {
  const removeAssignment = async (a: any) => {
    const orgId = store.getters['organisation/getOrganisationId'];
    await store.dispatch('courseAssignment/DELETE', { orgId, assignmentId: a.assignmentId });
    // Liste aus dem aktualisierten Store neu aufbauen
    openAssignmentsPopup(targetType, targetId, label);
  };
  const entries = [
    ...getCourseAssignmentsForTarget(targetType, targetId).map((a: any) => ({
      label: courseTitle(a.courseId),
      sub: a.deadline ? 'Kurs · Frist ' + fmtDate(a.deadline) : 'Kurs',
      onClick: () => { listPopup.value.visible = false; openEditAssignmentFromTarget(a); },
      onRemove: () => removeAssignment(a),
    })),
    ...getInstructionAssignmentsForTarget(targetType, targetId).map((a: any) => ({
      label: instructionTitle(a.instructionId),
      sub: a.deadline ? 'Unterweisung · Frist ' + fmtDate(a.deadline) : 'Unterweisung',
      onClick: () => { listPopup.value.visible = false; openEditAssignmentFromTarget(a); },
      onRemove: () => removeAssignment(a),
    })),
  ];
  openListPopup('Zuweisungen – ' + label, entries, {
    label: 'Aufgabe zuweisen',
    action: () => { listPopup.value.visible = false; openCreateAssignmentForTarget(targetType, targetId); },
  });
}

// Alle Aufgaben eines Mitarbeiters als Liste: direkt zugewiesene und die aus seinen Gruppen.
// Kurse zeigen ihren Abschluss-Status (im gewählten Jahr) und lassen sich von der
// Verwaltung manuell als erledigt markieren (z. B. auf einer alten Plattform absolviert).
function openUserTasksPopup(user: any) {
  const entries: ListPopupEntry[] = [];

  const pushAssignments = (targetType: 'USER' | 'GROUP', targetId: string, origin: string) => {
    for (const a of getCourseAssignmentsForTarget(targetType, targetId)) {
      const passedAt = userHasCourseCompleted(user.userId, a.courseId);
      entries.push({
        label: courseTitle(a.courseId),
        sub: [
          'Kurs',
          origin,
          a.deadline ? 'Frist ' + fmtDate(a.deadline) : '',
          passedAt ? 'Erledigt am ' + tsDate(passedAt) : '',
        ].filter(Boolean).join(' · '),
        onClick: () => { listPopup.value.visible = false; openEditAssignmentFromTarget(a); },
        action: passedAt ? undefined : { label: 'Als erledigt markieren', onClick: () => openMarkCompletedModal(user, a) },
      });
    }
    for (const a of getInstructionAssignmentsForTarget(targetType, targetId)) {
      const conf = (instructionCompletionsByUser.value[user.userId] || []).find((c) => c.instructionId === a.instructionId);
      entries.push({
        label: instructionTitle(a.instructionId),
        sub: [
          'Unterweisung',
          origin,
          a.deadline ? 'Frist ' + fmtDate(a.deadline) : '',
          conf ? 'Erledigt am ' + tsDate(conf.confirmedAt) : '',
        ].filter(Boolean).join(' · '),
        onClick: () => { listPopup.value.visible = false; openEditAssignmentFromTarget(a); },
      });
    }
  };

  pushAssignments('USER', user.userId, 'direkt zugewiesen');
  for (const groupId of (userGroupMemberships.value[user.userId] ?? [])) {
    const groupName = groups.value.find((g) => g.groupId === groupId)?.name ?? '';
    pushAssignments('GROUP', groupId, groupName ? `über Gruppe ${groupName}` : 'über Gruppe');
  }

  openListPopup('Aufgaben – ' + displayName(user), entries);
}

// ── Kurs manuell als erledigt markieren ───────────────────
// Für Fortbildungen, die außerhalb der Plattform absolviert wurden (z. B. auf
// einem Vorgängersystem). Schreibt die Activity des Mitarbeiters mit passedAt
// und Audit-Feldern (completedManually/completedBy) über den Admin-Endpunkt.
const markCompletedModal = ref<{ visible: boolean; user: any; courseId: string; date: string; saving: boolean; error: string }>({
  visible: false,
  user: null,
  courseId: '',
  date: '',
  saving: false,
  error: '',
});

function openMarkCompletedModal(user: any, assignment: any) {
  listPopup.value.visible = false;
  markCompletedModal.value = {
    visible: true,
    user,
    courseId: assignment.courseId,
    date: new Date().toISOString().slice(0, 10),
    saving: false,
    error: '',
  };
}

async function saveMarkCompleted() {
  const m = markCompletedModal.value;
  if (!m.date) {
    m.error = 'Bitte wählen Sie ein Abschlussdatum.';
    return;
  }
  m.saving = true;
  m.error = '';
  try {
    // Mittag statt Mitternacht, damit das Datum in allen Zeitzonen stabil bleibt
    const passedAt = new Date(m.date + 'T12:00:00').getTime();
    await completeForUser(
      store.getters['organisation/getOrganisationId'],
      m.user.userId,
      m.courseId,
      new Date(passedAt).getFullYear(),
      { passedAt },
      store.getters.getJWT,
    );
    await load();
    m.visible = false;
    openUserTasksPopup(m.user);
  } catch (e) {
    m.error = 'Der Abschluss konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.';
  } finally {
    m.saving = false;
  }
}

// Mitarbeiter aus der Tabelle einer Gruppe zuordnen (Plus in der Gruppen-Spalte):
// Dropdown mit allen Gruppen, aktuelle Mitgliedschaften vorausgewählt;
// jede Änderung (an-/abhaken) wird sofort gespeichert.
const userGroupModalVisible = ref(false);
const userGroupModalUser = ref<any>(null);

function openAddUserToGroupPopup(user: any) {
  userGroupModalUser.value = user;
  userGroupModalVisible.value = true;
}

async function onUserGroupsChange(next: string[]) {
  const user = userGroupModalUser.value;
  if (!user) return;
  const orgId = store.getters['organisation/getOrganisationId'];
  const jwt = store.getters.getJWT;
  const current = userGroupMemberships.value[user.userId] ?? [];
  const added = next.filter((id) => !current.includes(id));
  const removed = current.filter((id) => !next.includes(id));

  // Optimistisch aktualisieren, bei Fehler zurückrollen
  userGroupMemberships.value[user.userId] = next;
  try {
    for (const id of added) await addUserToGroup(orgId, id, user.userId, jwt);
    for (const id of removed) await removeUserFromGroup(orgId, id, user.userId, jwt);
  } catch {
    userGroupMemberships.value[user.userId] = current;
  }
}

// Ziele (wer ist zugewiesen) eines Kurses als Liste (Katalog-Tab)
function openCourseTargetsPopup(course: any) {
  const entries = getAssignmentsForCourse(course.id).map((a: any) => ({
    label: assignmentChipLabel(a),
    onClick: () => { listPopup.value.visible = false; openEditAssignment(course, a); },
  }));
  openListPopup('Zuweisungen – ' + course.title, entries);
}

const courseAssignSaving = ref(false);
const courseAssignError = ref('');

// Returns the course title for a given courseId (for displaying in group/user tab chips)
function courseTitle(courseId: string): string {
  const c = (catalogCourses.value as any[]).find((m: any) => m.id === courseId);
  if (c) return c.title;
  // Fallback: Slug lesbar machen ("harnkontinenz-pflege" -> "Harnkontinenz Pflege")
  return (courseId || '')
    .split(/[-_]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ') || courseId;
}

// All assignments for a specific course (used in catalog tab chips)
function getAssignmentsForCourse(courseId: string): any[] {
  return store.getters['courseAssignment/getAssignmentsByCourse'](courseId);
}

// All assignments for a specific target (used in groups/users tab chips)
function getAssignmentsForTarget(targetType: string, targetId: string): any[] {
  return store.getters['courseAssignment/getAssignmentsByTarget'](targetType, targetId);
}

// Chip label when displaying from catalog tab (shows who the assignment is for)
function assignmentChipLabel(a: any): string {
  const grp = (groups.value as any[]).find((g: any) => g.groupId === a.targetId);
  const usr = (users.value as any[]).find((u: any) => u.userId === a.targetId);
  const label = a.targetType === 'GROUP'
    ? (grp ? grp.name : a.targetId)
    : displayName(usr ? usr : { userId: a.targetId });
  return a.deadline
    ? label + ' (bis ' + new Date(a.deadline).toLocaleDateString('de-DE') + ')'
    : label;
}

// Chip label when displaying from groups/users tab (shows which course)
function assignmentCourseChipLabel(a: any): string {
  const title = courseTitle(a.courseId);
  return a.deadline
    ? title + ' (bis ' + new Date(a.deadline).toLocaleDateString('de-DE') + ')'
    : title;
}

// Open from catalog tab: course is pre-selected, user picks target
function openCreateAssignment(course: any) {
  courseAssignModalCourse.value = course;
  courseAssignModalMode.value = 'create';
  courseAssignTargetFixed.value = false;
  editingAssignment.value = null;
  courseAssignForm.value = { kind: 'course', instructionId: '', instructionIds: [], courseId: course.id, courseIds: [course.id], targetType: 'GROUP', targetId: '', targetIds: [], deadline: '', recurAnnually: false, notifyDaysBefore: null, notifyCount: null };
  courseAssignError.value = '';
  courseAssignModalVisible.value = true;
}

// Open from groups/users tab: target is pre-selected, user picks course
function openCreateAssignmentForTarget(targetType: 'GROUP' | 'USER', targetId: string) {
  courseAssignModalCourse.value = null;
  courseAssignModalMode.value = 'create';
  courseAssignTargetFixed.value = true;
  editingAssignment.value = null;
  courseAssignForm.value = { kind: 'course', instructionId: '', instructionIds: [], courseId: '', courseIds: [], targetType, targetId, targetIds: [targetId], deadline: '', recurAnnually: false, notifyDaysBefore: null, notifyCount: null };
  courseAssignError.value = '';
  courseAssignModalVisible.value = true;
}

// Open from the Unterweisungen tab: instruction is pre-selected, user picks target
function openCreateAssignmentForInstruction(instructionId: string) {
  courseAssignModalCourse.value = null;
  courseAssignModalMode.value = 'create';
  courseAssignTargetFixed.value = false;
  editingAssignment.value = null;
  courseAssignForm.value = { kind: 'instruction', instructionId, instructionIds: [instructionId], courseId: '', courseIds: [], targetType: 'GROUP', targetId: '', targetIds: [], deadline: '', recurAnnually: false, notifyDaysBefore: null, notifyCount: null };
  courseAssignError.value = '';
  courseAssignModalVisible.value = true;
}

// Edit existing assignment (Kurs ODER Unterweisung)
function openEditAssignment(course: any, assignment: any) {
  const isInstruction = assignment.kind === 'INSTRUCTION';
  courseAssignModalCourse.value = isInstruction ? null : course;
  courseAssignModalMode.value = 'edit';
  courseAssignTargetFixed.value = true;  // target is never editable in edit mode
  editingAssignment.value = assignment;
  courseAssignForm.value = {
    kind: isInstruction ? 'instruction' : 'course',
    instructionId: assignment.instructionId || '',
    instructionIds: assignment.instructionId ? [assignment.instructionId] : [],
    courseId: assignment.courseId || '',
    courseIds: assignment.courseId ? [assignment.courseId] : [],
    targetType: assignment.targetType,
    targetId: assignment.targetId,
    targetIds: [assignment.targetId],
    deadline: assignment.deadline || '',
    recurAnnually: assignment.recurAnnually,
    notifyDaysBefore: assignment.notifyDaysBefore,
    notifyCount: assignment.notifyCount,
  };
  courseAssignError.value = '';
  courseAssignModalVisible.value = true;
}

// Edit from groups/users tab: resolve course name from catalog (bei Kursen)
function openEditAssignmentFromTarget(assignment: any) {
  const course = assignment.kind === 'INSTRUCTION'
    ? null
    : (catalogCourses.value as any[]).find((c: any) => c.id === assignment.courseId) || null;
  openEditAssignment(course, assignment);
}

async function saveAssignment() {
  const isInstruction = courseAssignForm.value.kind === 'instruction';
  const isCreate = courseAssignModalMode.value === 'create';

  // Kurse bzw. Unterweisungen: beim Anlegen Mehrfachauswahl, beim Bearbeiten Einzelwert
  const refIds = isCreate
    ? (isInstruction
        ? courseAssignForm.value.instructionIds
        : (courseAssignModalCourse.value ? [courseAssignModalCourse.value.id] : courseAssignForm.value.courseIds))
    : [isInstruction
        ? courseAssignForm.value.instructionId
        : (courseAssignModalCourse.value ? courseAssignModalCourse.value.id : courseAssignForm.value.courseId)];
  const targetIds = isCreate ? courseAssignForm.value.targetIds : [courseAssignForm.value.targetId];
  if (!targetIds.length || !refIds.length || refIds.some((r) => !r)) return;

  courseAssignSaving.value = true;
  courseAssignError.value = '';
  const orgId = store.getters['organisation/getOrganisationId'];
  const basePayload: any = {
    kind: isInstruction ? 'INSTRUCTION' : 'COURSE',
    targetType: courseAssignForm.value.targetType,
    deadline: courseAssignForm.value.deadline || null,
    recurAnnually: courseAssignForm.value.recurAnnually,
    notifyDaysBefore: courseAssignForm.value.notifyDaysBefore,
    notifyCount: courseAssignForm.value.notifyCount,
  };

  try {
    if (isCreate) {
      // Eine Zuweisung pro Kombination aus Kurs/Unterweisung und Ziel anlegen
      const failed: { refId: string; targetId: string }[] = [];
      let total = 0;
      for (const refId of refIds) {
        for (const targetId of targetIds) {
          total++;
          const payload = isInstruction
            ? { ...basePayload, instructionId: refId, targetId }
            : { ...basePayload, courseId: refId, targetId };
          try {
            await store.dispatch('courseAssignment/CREATE', { orgId, payload });
          } catch (e) {
            failed.push({ refId, targetId });
          }
        }
      }
      if (failed.length) {
        // Auswahl auf die fehlgeschlagenen Einträge reduzieren, damit ein
        // erneutes Speichern möglichst keine Duplikate anlegt
        courseAssignForm.value.targetIds = [...new Set(failed.map((f) => f.targetId))];
        const failedRefs = [...new Set(failed.map((f) => f.refId))];
        if (isInstruction) courseAssignForm.value.instructionIds = failedRefs;
        else courseAssignForm.value.courseIds = failedRefs;
        courseAssignError.value = failed.length === total
          ? 'Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.'
          : `${total - failed.length} von ${total} Zuweisungen gespeichert. Bitte versuchen Sie es für die verbleibenden erneut.`;
        return;
      }
    } else {
      const payload = isInstruction
        ? { ...basePayload, instructionId: refIds[0], targetId: courseAssignForm.value.targetId }
        : { ...basePayload, courseId: refIds[0], targetId: courseAssignForm.value.targetId };
      await store.dispatch('courseAssignment/UPDATE', {
        orgId,
        assignmentId: editingAssignment.value.assignmentId,
        payload,
      });
    }
    courseAssignModalVisible.value = false;
  } catch (e) {
    courseAssignError.value = 'Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.';
  } finally {
    courseAssignSaving.value = false;
  }
}

async function doDeleteAssignment() {
  if (!editingAssignment.value) return;
  const orgId = store.getters['organisation/getOrganisationId'];
  await store.dispatch('courseAssignment/DELETE', {
    orgId,
    assignmentId: editingAssignment.value.assignmentId,
  });
  courseAssignModalVisible.value = false;
}

// Load all assignments when groups or users tabs open; per-course when catalog opens
watch(activeTab, async (tab) => {
  const orgId = store.getters['organisation/getOrganisationId'];
  if (tab === 'catalog') {
    catalogLoading.value = true;
    await store.dispatch('lmsCourse/LOAD_CATALOG');
    catalogLoading.value = false;
    // If LOAD_ALL already ran (from groups/users tab), no need to do per-course loading
    if (!store.getters['courseAssignment/isAllLoaded']) {
      const courses = store.getters['lmsCourse/getModules'] as any[];
      await Promise.all(
        courses.map((c: any) =>
          store.dispatch('courseAssignment/LOAD_FOR_COURSE', { orgId, courseId: c.id })
        )
      );
    }
  } else if (tab === 'groups' || tab === 'users') {
    // Load catalog so courseTitle() works in chips
    store.dispatch('lmsCourse/LOAD_CATALOG');
    // Load all assignments once
    store.dispatch('courseAssignment/LOAD_ALL', orgId);
  }
});

// ── Aktivitäten ───────────────────────────────────────────
const courseYears = { 2022: 2022, 2023: 2023, 2024: 2024, 2025: 2025, 2026: 2026 };
const selectYear = ref(new Date().getFullYear());
const courses = ref<any[]>([]);
// getCourses uses the superadmin catalog (same source as catalogCourses)
const getCourses = computed(() => store.getters['lmsCourse/getModules']);

watch(selectYear, () => load());

function userHasCourseCompleted(userId: string, courseId: string) {
  const t = courses.value.find((i: any) => i.courseId == courseId && i.userId == userId);
  return t && t.passedAt ? t.passedAt : false;
}

async function load() {
  courses.value = [];
  const res = await getAllByOrganisation(
    store.getters['organisation/getOrganisationId'],
    selectYear.value,
    store.getters.getJWT
  );
  res.forEach((item: any) => courses.value.push(item));
}

async function getCompanyPDF() {
  await displayPDFByOrg(getCourses.value, users.value, selectYear.value, store, courses.value);
}

async function getUserPDF(userId: any) {
  await displayPDFByUser(
    getCourses.value,
    users.value.filter((u: any) => u.userId == userId),
    selectYear.value,
    store,
    courses.value
  );
}

// ── Abschlüsse: Kurse + Unterweisungen, Zertifikate (Browser-Druck) ──
const instructionCompletionsByUser = ref<Record<string, { instructionId: string; title: string; confirmedAt: number }[]>>({});

async function loadInstructionCompletions() {
  const orgId = store.getters['organisation/getOrganisationId'];
  if (!orgId) return;
  await store.dispatch('instruction/LOAD_ALL', { force: true });
  const list: any[] = store.getters['instruction/getAll'] || [];
  await Promise.all(list.map((i) => store.dispatch('instruction/LOAD_CONFIRMATIONS', i.instructionId).catch(() => [])));
  const byUser: Record<string, { instructionId: string; title: string; confirmedAt: number }[]> = {};
  list.forEach((ins) => {
    const confs: any[] = store.getters['instruction/getConfirmations'](ins.instructionId) || [];
    confs.forEach((c) => {
      (byUser[c.userId] = byUser[c.userId] || []).push({ instructionId: ins.instructionId, title: ins.title, confirmedAt: c.confirmedAt });
    });
  });
  instructionCompletionsByUser.value = byUser;
}

function tsDate(ts: number): string {
  return ts ? new Date(ts).toLocaleDateString('de-DE') : '';
}

function completedCoursesForUser(userId: string): CertItem[] {
  return courses.value
    .filter((a: any) => a.userId === userId && a.passedAt)
    .map((a: any) => ({ label: courseTitle(a.courseId), type: 'Kurs', date: tsDate(a.passedAt) }));
}

function completedInstructionsForUser(userId: string): CertItem[] {
  const confs = instructionCompletionsByUser.value[userId] || [];
  return confs
    .filter((c) => new Date(c.confirmedAt).getFullYear() === Number(selectYear.value))
    .map((c) => ({ label: c.title, type: 'Unterweisung', date: tsDate(c.confirmedAt) }));
}

function userHasAnyCompletion(userId: string): boolean {
  return completedCoursesForUser(userId).length > 0 || completedInstructionsForUser(userId).length > 0;
}

const orgNameForCert = computed(() => (organisation.value && organisation.value.name) || 'Einrichtung');
function today(): string { return new Date().toLocaleDateString('de-DE'); }

// Popup mit Liste der Abschlüsse; Klick auf Eintrag -> Einzel-Zertifikat
function openCompletionsPopup(user: any, items: CertItem[], title: string) {
  const name = displayName(user) || user.email || user.userName;
  const entries = items.map((it) => ({
    label: it.label,
    sub: it.type + ' · ' + it.date,
    onClick: () => {
      listPopup.value.visible = false;
      printCertificate({ orgName: orgNameForCert.value, employeeName: name, items: [it], dateStr: today() });
    },
  }));
  openListPopup(title + ' – ' + name, entries);
}

// Sammel-Zertifikat einer Person (alle Abschlüsse)
function printUserCombined(user: any) {
  const items = [...completedCoursesForUser(user.userId), ...completedInstructionsForUser(user.userId)];
  if (!items.length) return;
  printCertificate({
    orgName: orgNameForCert.value,
    employeeName: displayName(user) || user.email || user.userName,
    items,
    dateStr: today(),
  });
}

// Gesamtübersicht der ganzen Einrichtung
function printOrgOverviewAll() {
  const rows = (users.value as any[])
    .map((u: any) => ({
      name: displayName(u) || u.email || u.userName,
      items: [...completedCoursesForUser(u.userId), ...completedInstructionsForUser(u.userId)],
    }))
    .filter((r) => r.items.length > 0);
  printOrgOverview({ orgName: orgNameForCert.value, year: selectYear.value, dateStr: today(), rows });
}

// ── Einstellungen ─────────────────────────────────────────
const settingsForm = ref({ name: '', street: '', streetNo: '', addressAddition: '', postalCode: '', city: '' });
const settingsSaving = ref(false);
const settingsSaved = ref(false);
const logoPreview = ref<string | null>(null);
const logoUploading = ref(false);
const logoError = ref('');

watch(organisation, (org) => {
  if (!org) return;
  const c = org.data?.company || {};
  if (org.data?.logoUrl) logoPreview.value = org.data.logoUrl;
  settingsForm.value = {
    name: org.name || '',
    street: c.street || '',
    streetNo: c.streetNo || '',
    addressAddition: c.addressAddition || '',
    postalCode: c.postalCode || '',
    city: c.city || '',
  };
}, { immediate: true });

async function handleLogoUpload(event: Event) {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (!file) return;
  logoError.value = '';
  logoUploading.value = true;
  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    const publicUrl = await uploadLogo(orgId, file, store.getters.getJWT);
    logoPreview.value = publicUrl;
    // Logo-URL in Org-Daten speichern; bestehende Daten mergen, nicht ersetzen
    await store.dispatch('organisation/UPDATE', {
      ...(organisation.value?.data || {}),
      company: { ...settingsForm.value },
      logoUrl: publicUrl,
    });
  } catch {
    logoError.value = 'Upload fehlgeschlagen. Bitte versuchen Sie es erneut.';
  } finally {
    logoUploading.value = false;
  }
}

async function saveSettings() {
  settingsSaving.value = true;
  settingsSaved.value = false;
  try {
    // bestehende Daten (z. B. logoUrl) mergen, nicht ersetzen
    await store.dispatch('organisation/UPDATE', {
      ...(organisation.value?.data || {}),
      company: { ...settingsForm.value },
    });
    settingsSaved.value = true;
    setTimeout(() => { settingsSaved.value = false; }, 3000);
  } finally {
    settingsSaving.value = false;
  }
}

// ── Gruppen ───────────────────────────────────────────────
// weight/parentGroupId sind erst ab organisation-SDK > 1.27 typisiert;
// der Service unterstützt sie bereits. Cast entfällt nach dem SDK-Bump.
const updateGroupFull = updateGroupApi as unknown as (
  organisationId: string,
  groupId: string,
  data: { name?: string; parentGroupId?: string | null; weight?: number },
  JWT: string,
) => Promise<GroupNode>;

const groups = ref<GroupNode[]>([]);
const groupModalMode = ref<'create' | 'edit'>('create');
const groupModalVisible = ref(false);
const groupModalParentId = ref<string | null>(null);
const groupModalEditId = ref<string | null>(null);
const groupModalName = ref('');
const groupModalWeight = ref<number | null>(null);
const groupModalSaving = ref(false);
const groupError = ref('');
const groupDragActive = ref(false);
const groupDragError = ref('');
let groupDragErrorTimer: ReturnType<typeof setTimeout> | undefined;

// Assign modal
const assignModalVisible = ref(false);
const assignModalGroup = ref<Group | null>(null);
const assignSearch = ref('');
const assignLoadingMembers = ref(false);
const groupAssignPanelMembers = ref<string[]>([]);

// Group membership map: userId → groupId[]
const userGroupMemberships = ref<Record<string, string[]>>({});

const assignFilteredUsers = computed(() => {
  const q = assignSearch.value.toLowerCase().trim();
  if (!q) return users.value;
  return (users.value as any[]).filter((u: any) => {
    const name = displayName(u).toLowerCase();
    const email = (u.email || u.userName || '').toLowerCase();
    return name.includes(q) || email.includes(q);
  });
});

// Remove-from-group confirmation
const removeGroupConfirm = ref<{ userId: string; groupId: string } | null>(null);

function removeUserFromGroupDirect(userId: string, groupId: string) {
  removeGroupConfirm.value = { userId, groupId };
}

async function confirmRemoveFromGroup() {
  if (!removeGroupConfirm.value) return;
  const { userId, groupId } = removeGroupConfirm.value;
  const orgId = store.getters['organisation/getOrganisationId'];
  await removeUserFromGroup(orgId, groupId, userId, store.getters.getJWT);
  if (userGroupMemberships.value[userId]) {
    userGroupMemberships.value[userId] = userGroupMemberships.value[userId].filter((id) => id !== groupId);
  }
  removeGroupConfirm.value = null;
}

function userGroupNames(userId: string): string {
  const groupIds = userGroupMemberships.value[userId] ?? [];
  return groupIds
    .map((id) => groups.value.find((g) => g.groupId === id)?.name ?? '')
    .filter(Boolean)
    .join(', ');
}

function groupChildren(parentId: string | null): GroupNode[] {
  return groups.value
    .filter((g) => (g.parentGroupId ?? null) === parentId)
    .sort(
      (a, b) =>
        (a.weight ?? Number.MAX_SAFE_INTEGER) - (b.weight ?? Number.MAX_SAFE_INTEGER) ||
        a.createdAt - b.createdAt
    );
}

/** Alle Gruppen in Hierarchie-Reihenfolge (wie im Gruppen-Tab) mit Einrückung
 *  fürs native <select>. Gruppen, deren Elterngruppe fehlt, werden ans Ende
 *  angehängt, damit keine Gruppe aus der Auswahl fällt. */
const groupOptions = computed<{ groupId: string; label: string }[]>(() => {
  const options: { groupId: string; label: string }[] = [];
  const seen = new Set<string>();
  function walk(parentId: string | null, depth: number) {
    for (const g of groupChildren(parentId)) {
      if (seen.has(g.groupId)) continue;
      seen.add(g.groupId);
      const indent = '\u00A0\u00A0\u00A0'.repeat(depth);
      options.push({ groupId: g.groupId, label: depth > 0 ? `${indent}↳ ${g.name}` : g.name });
      walk(g.groupId, depth + 1);
    }
  }
  walk(null, 0);
  for (const g of groups.value) {
    if (!seen.has(g.groupId)) {
      options.push({ groupId: g.groupId, label: g.name });
    }
  }
  return options;
});

/** Tiefe des Teilbaums unterhalb von groupId (1 = keine Kinder). */
function groupSubtreeDepth(groupId: string): number {
  const children = groups.value.filter((g) => g.parentGroupId === groupId);
  if (!children.length) return 1;
  return 1 + Math.max(...children.map((c) => groupSubtreeDepth(c.groupId)));
}

function groupDescendants(groupId: string): GroupNode[] {
  const children = groups.value.filter((g) => g.parentGroupId === groupId);
  return children.concat(...children.map((c) => groupDescendants(c.groupId)));
}

function showGroupDragError(message: string) {
  groupDragError.value = message;
  if (groupDragErrorTimer) clearTimeout(groupDragErrorTimer);
  groupDragErrorTimer = setTimeout(() => { groupDragError.value = ''; }, 5000);
}

function onGroupDragChange(evt: any, newParentId: string | null) {
  // Bei Listenwechsel feuert die Zielliste 'added', die Quellliste 'removed' —
  // 'removed' wird deshalb ignoriert.
  const info = evt.added ?? evt.moved;
  if (!info) return;
  // Zielgruppe aufklappen, damit die abgelegte Gruppe sichtbar bleibt
  if (evt.added && newParentId) expandGroup(newParentId);
  void persistGroupMove(info.element.groupId, newParentId, info.newIndex);
}

// ── Auf-/Zuklappen von Gruppen mit Untergruppen ───────────
// Standardmäßig sind alle Gruppen mit Untergruppen zugeklappt (Initialisierung
// beim ersten Laden in loadGroups); danach bleibt der Zustand erhalten.
const collapsedGroups = ref<Set<string>>(new Set());
let groupCollapseInitialized = false;

function isGroupCollapsed(groupId: string): boolean {
  return collapsedGroups.value.has(groupId);
}

function toggleGroupCollapse(groupId: string) {
  const next = new Set(collapsedGroups.value);
  if (next.has(groupId)) next.delete(groupId);
  else next.add(groupId);
  collapsedGroups.value = next;
}

function expandGroup(groupId: string) {
  if (!collapsedGroups.value.has(groupId)) return;
  const next = new Set(collapsedGroups.value);
  next.delete(groupId);
  collapsedGroups.value = next;
}

async function persistGroupMove(groupId: string, newParentId: string | null, newIndex: number) {
  const moved = groups.value.find((g) => g.groupId === groupId);
  if (!moved) return;
  const oldParentId = moved.parentGroupId ?? null;
  const parentChanged = oldParentId !== newParentId;

  if (parentChanged) {
    const parent = newParentId ? groups.value.find((g) => g.groupId === newParentId) : null;
    if (newParentId && !parent) return;
    const newLevel = parent ? parent.level + 1 : 1;
    if (newLevel + groupSubtreeDepth(groupId) - 1 > 3) {
      showGroupDragError('Verschieben nicht möglich: Es sind höchstens drei Ebenen erlaubt.');
      // Re-Render aus dem unveränderten Zustand stellt die alte Position wieder her.
      groups.value = [...groups.value];
      return;
    }
    const levelDelta = newLevel - moved.level;
    if (levelDelta !== 0) groupDescendants(groupId).forEach((d) => { d.level += levelDelta; });
    moved.level = newLevel;
    moved.parentGroupId = newParentId;
  }

  // Neue Reihenfolge der Ziel-Geschwister; weight = Index, nur Änderungen speichern.
  const siblings = groupChildren(newParentId).filter((g) => g.groupId !== groupId);
  siblings.splice(newIndex, 0, moved);

  const updates: Array<{ groupId: string; data: { parentGroupId?: string | null; weight?: number } }> = [];
  siblings.forEach((g, i) => {
    const data: { parentGroupId?: string | null; weight?: number } = {};
    if (g.weight !== i) { g.weight = i; data.weight = i; }
    if (g.groupId === groupId && parentChanged) data.parentGroupId = newParentId;
    if (Object.keys(data).length) updates.push({ groupId: g.groupId, data });
  });
  if (!updates.length) return;

  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    const jwt = store.getters.getJWT;
    await Promise.all(updates.map((u) => updateGroupFull(orgId, u.groupId, u.data, jwt)));
  } catch {
    showGroupDragError('Die Änderung konnte nicht gespeichert werden. Die Ansicht wurde zurückgesetzt.');
    await loadGroups();
  }
}

/** Mitarbeiter, die dieser Gruppe direkt zugeordnet sind. */
function groupMembers(groupId: string): any[] {
  return users.value.filter((u: any) =>
    (userGroupMemberships.value[u.userId] ?? []).includes(groupId)
  );
}

function openCreateGroup(parentId: string | null = null) {
  groupModalMode.value = 'create';
  groupModalParentId.value = parentId;
  groupModalEditId.value = null;
  groupModalName.value = '';
  groupModalWeight.value = null;
  groupError.value = '';
  groupModalVisible.value = true;
}

function openEditGroup(group: GroupNode) {
  groupModalMode.value = 'edit';
  groupModalEditId.value = group.groupId;
  groupModalParentId.value = group.parentGroupId ?? null;
  groupModalName.value = group.name;
  groupModalWeight.value = typeof group.weight === 'number' ? group.weight : null;
  groupError.value = '';
  groupModalVisible.value = true;
}

async function saveGroupModal() {
  if (!groupModalName.value.trim()) { groupError.value = 'Bitte einen Namen eingeben.'; return; }
  groupModalSaving.value = true;
  groupError.value = '';
  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    const jwt = store.getters.getJWT;
    if (groupModalMode.value === 'create') {
      const created = await createGroup(orgId, { name: groupModalName.value.trim(), parentGroupId: groupModalParentId.value }, jwt);
      groups.value.push(created);
    } else if (groupModalEditId.value) {
      const data: { name: string; weight?: number } = { name: groupModalName.value.trim() };
      if (typeof groupModalWeight.value === 'number' && Number.isFinite(groupModalWeight.value)) {
        data.weight = groupModalWeight.value;
      }
      const updated = await updateGroupFull(orgId, groupModalEditId.value, data, jwt);
      const idx = groups.value.findIndex((g) => g.groupId === groupModalEditId.value);
      if (idx >= 0) groups.value[idx] = updated;
    }
    groupModalVisible.value = false;
  } catch (e: any) {
    groupError.value = e?.response?.data?.['error-message'] ?? 'Ein Fehler ist aufgetreten.';
  } finally {
    groupModalSaving.value = false;
  }
}

async function confirmDeleteGroup(group: Group) {
  if (!confirm(`Gruppe „${group.name}" wirklich löschen? Alle Mitgliedschaften werden aufgehoben.`)) return;
  const orgId = store.getters['organisation/getOrganisationId'];
  await deleteGroup(orgId, group.groupId, store.getters.getJWT);
  groups.value = groups.value.filter((g) => g.groupId !== group.groupId);
}

async function openAssignModal(group: Group) {
  assignModalGroup.value = group;
  assignSearch.value = '';
  groupAssignPanelMembers.value = [];
  assignLoadingMembers.value = true;
  assignModalVisible.value = true;
  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    const members = await import('@training24/organisation/src/group').then((m) =>
      m.getUsersInGroup(orgId, group.groupId, store.getters.getJWT)
    );
    groupAssignPanelMembers.value = members.map((m: any) => m.userId);
  } finally {
    assignLoadingMembers.value = false;
  }
}

async function closeAssignModal() {
  assignModalVisible.value = false;
  assignModalGroup.value = null;
  await loadGroupMemberships();
}

async function toggleGroupMember(userId: string) {
  const groupId = assignModalGroup.value?.groupId;
  if (!groupId) return;
  const orgId = store.getters['organisation/getOrganisationId'];
  const jwt = store.getters.getJWT;
  const isMember = groupAssignPanelMembers.value.includes(userId);
  if (isMember) {
    await removeUserFromGroup(orgId, groupId, userId, jwt);
    groupAssignPanelMembers.value = groupAssignPanelMembers.value.filter((id) => id !== userId);
  } else {
    await addUserToGroup(orgId, groupId, userId, jwt);
    groupAssignPanelMembers.value.push(userId);
  }
}

async function loadGroups() {
  const orgId = store.getters['organisation/getOrganisationId'];
  if (!orgId) return;
  groups.value = await getGroups(orgId, store.getters.getJWT);
  if (!groupCollapseInitialized) {
    groupCollapseInitialized = true;
    // Alle Gruppen mit Untergruppen starten zugeklappt
    collapsedGroups.value = new Set(
      groups.value
        .map((g) => g.parentGroupId)
        .filter((id): id is string => !!id)
    );
  }
}

async function loadGroupMemberships() {
  const orgId = store.getters['organisation/getOrganisationId'];
  if (!orgId || groups.value.length === 0) return;
  const jwt = store.getters.getJWT;
  const map: Record<string, string[]> = {};
  await Promise.all(
    groups.value.map(async (group) => {
      try {
        const members = await import('@training24/organisation/src/group').then((m) =>
          m.getUsersInGroup(orgId, group.groupId, jwt)
        );
        for (const m of members as any[]) {
          if (!map[m.userId]) map[m.userId] = [];
          map[m.userId].push(group.groupId);
        }
      } catch (e) { /* Gruppe ohne Mitglieder oder Fehler — überspringen */ }
    })
  );
  userGroupMemberships.value = map;
}

/** Nach Anlegen eines Mitarbeiters: Liste und Gruppenzuordnungen neu laden */
async function onUserCreated() {
  await loadProfiles();
  await loadGroupMemberships();
}

// ── Lifecycle ─────────────────────────────────────────────
// OrgId schon da (SPA-Navigation von /lms hierher): direkt laden.
// Sonst übernimmt der currentOrgId-watch oben, sobald sie gesetzt wird.
onMounted(() => {
  if (currentOrgId.value) initLoads(currentOrgId.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(organisation)?.name ?? 'Meine Einrichtung'), 1),
        _createElementVNode("nav", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.id,
              class: _normalizeClass(["tab-btn", { active: activeTab.value === tab.id }]),
              onClick: ($event: any) => (activeTab.value = tab.id)
            }, _toDisplayString(tab.label), 11, _hoisted_5))
          }), 128))
        ])
      ]),
      (activeTab.value === 'users')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userSearch).value = $event)),
                  type: "search",
                  class: "reminder-search",
                  placeholder: "Nach Name oder E-Mail suchen",
                  "aria-label": "Mitarbeiter nach Name oder E-Mail suchen"
                }, null, 512), [
                  [_vModelText, userSearch.value]
                ]),
                _createElementVNode("a", _hoisted_10, [
                  _createVNode(_unref(UserPlusIcon), { size: "16" }),
                  _createTextVNode(" Mitarbeiter anlegen ")
                ])
              ])
            ]),
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("table", _hoisted_13, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    _createElementVNode("th", null, [
                      _createElementVNode("span", _hoisted_18, [
                        _createTextVNode(" Aufgaben "),
                        _createElementVNode("span", _hoisted_19, [
                          _createElementVNode("button", _hoisted_20, [
                            _createVNode(_unref(InfoIcon), { size: "13" })
                          ]),
                          _hoisted_21
                        ])
                      ])
                    ]),
                    _hoisted_22
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredUsers), (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.userId
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_23, [
                          _createTextVNode(_toDisplayString(userFirstName(user)) + " ", 1),
                          (user.type === 'OWNER' || user.type === 'ADMIN')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Admin"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(userLastName(user)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(user.email || user.userName), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((userGroupMemberships.value[user.userId] ?? []), (groupId) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: groupId,
                              class: "group-chip",
                              title: `Aus ${groups.value.find(g => g.groupId === groupId)?.name ?? ''} entfernen`,
                              onClick: ($event: any) => (removeUserFromGroupDirect(user.userId, groupId))
                            }, [
                              _createTextVNode(_toDisplayString(groups.value.find(g => g.groupId === groupId)?.name ?? groupId), 1),
                              _hoisted_29
                            ], 8, _hoisted_28))
                          }), 128)),
                          _createElementVNode("button", {
                            class: "chip-add-btn",
                            title: "Zu Gruppe hinzufügen",
                            onClick: ($event: any) => (openAddUserToGroupPopup(user))
                          }, [
                            _createVNode(_unref(PlusIcon), { size: "13" })
                          ], 8, _hoisted_30)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_31, [
                          (userTaskCount(user) > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "count-chip",
                                onClick: ($event: any) => (openUserTasksPopup(user))
                              }, _toDisplayString(userTaskCount(user)) + " " + _toDisplayString(userTaskCount(user) === 1 ? 'Aufgabe' : 'Aufgaben'), 9, _hoisted_32))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "chip-add-btn",
                            title: "Aufgabe zuweisen",
                            onClick: ($event: any) => (openCreateAssignmentForTarget('USER', user.userId))
                          }, [
                            _createVNode(_unref(PlusIcon), { size: "13" })
                          ], 8, _hoisted_33)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("button", {
                            class: "icon-btn",
                            title: "Bearbeiten",
                            onClick: ($event: any) => (openEditUser(user))
                          }, [
                            _createVNode(_unref(Edit2Icon), { size: "15" })
                          ], 8, _hoisted_36),
                          (user.type !== 'OWNER')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "icon-btn danger",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#deleteUser",
                                onClick: ($event: any) => (selectedUserUserId.value = user.userId),
                                title: "Entfernen"
                              }, [
                                _createVNode(_unref(TrashIcon), { size: "16" })
                              ], 8, _hoisted_37))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128)),
                  (_unref(users).length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_38, _hoisted_40))
                    : (_unref(filteredUsers).length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_41, _hoisted_43))
                      : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'groups')
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  class: "btn-ghost",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (openCreateGroup(null)))
                }, [
                  _createVNode(_unref(PlusIcon), { size: "16" }),
                  _createTextVNode(" Gruppe anlegen ")
                ])
              ])
            ]),
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              (groups.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, " Noch keine Gruppen angelegt. "))
                : _createCommentVNode("", true),
              (groupDragError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(groupDragError.value), 1))
                : _createCommentVNode("", true),
              _createVNode(_unref(draggable), {
                list: groupChildren(null),
                "item-key": "groupId",
                group: "org-groups",
                class: "group-root-list",
                animation: 160,
                "ghost-class": "group-drag-ghost",
                filter: "button, a",
                "prevent-on-filter": false,
                "force-fallback": true,
                "fallback-tolerance": 4,
                onStart: _cache[6] || (_cache[6] = ($event: any) => (groupDragActive.value = true)),
                onEnd: _cache[7] || (_cache[7] = ($event: any) => (groupDragActive.value = false)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (onGroupDragChange($event, null)))
              }, {
                item: _withCtx(({ element: rootGroup }) => [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      (groupChildren(rootGroup.groupId).length)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["icon-btn group-collapse-btn", { collapsed: isGroupCollapsed(rootGroup.groupId) }]),
                            title: isGroupCollapsed(rootGroup.groupId) ? 'Untergruppen anzeigen' : 'Untergruppen ausblenden',
                            "aria-expanded": !isGroupCollapsed(rootGroup.groupId),
                            onClick: ($event: any) => (toggleGroupCollapse(rootGroup.groupId))
                          }, [
                            _createVNode(_unref(ChevronDownIcon), { size: "16" })
                          ], 10, _hoisted_54))
                        : (_openBlock(), _createElementBlock("span", _hoisted_55)),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, _toDisplayString(rootGroup.name), 1),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_unref(BookOpenIcon), {
                              size: "12",
                              class: "group-member-icon"
                            }),
                            _createElementVNode("button", {
                              class: "count-chip",
                              onClick: ($event: any) => (openAssignmentsPopup('GROUP', rootGroup.groupId, rootGroup.name))
                            }, _toDisplayString(assignmentCountForTarget('GROUP', rootGroup.groupId)) + " " + _toDisplayString(assignmentCountForTarget('GROUP', rootGroup.groupId) === 1 ? 'Aufgabe' : 'Aufgaben'), 9, _hoisted_60)
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("button", {
                              class: "count-chip",
                              onClick: ($event: any) => (openAssignModal(rootGroup))
                            }, _toDisplayString(groupMembers(rootGroup.groupId).length) + " Mitarbeiter", 9, _hoisted_62)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("button", {
                          class: "icon-btn",
                          title: "Umbenennen",
                          onClick: ($event: any) => (openEditGroup(rootGroup))
                        }, [
                          _createVNode(_unref(Edit2Icon), { size: "15" })
                        ], 8, _hoisted_64),
                        _createElementVNode("button", {
                          class: "icon-btn danger",
                          title: "Löschen",
                          onClick: ($event: any) => (confirmDeleteGroup(rootGroup))
                        }, [
                          _createVNode(_unref(TrashIcon), { size: "15" })
                        ], 8, _hoisted_65)
                      ])
                    ]),
                    ((groupChildren(rootGroup.groupId).length && !isGroupCollapsed(rootGroup.groupId)) || groupDragActive.value)
                      ? (_openBlock(), _createBlock(_unref(draggable), {
                          key: 0,
                          list: groupChildren(rootGroup.groupId),
                          "item-key": "groupId",
                          group: "org-groups",
                          class: _normalizeClass(["group-children", { 'group-drop-zone': groupDragActive.value && groupChildren(rootGroup.groupId).length === 0 }]),
                          animation: 160,
                          "ghost-class": "group-drag-ghost",
                          filter: "button, a",
                          "prevent-on-filter": false,
                          "force-fallback": true,
                          "fallback-tolerance": 4,
                          onStart: _cache[4] || (_cache[4] = ($event: any) => (groupDragActive.value = true)),
                          onEnd: _cache[5] || (_cache[5] = ($event: any) => (groupDragActive.value = false)),
                          onChange: ($event: any) => (onGroupDragChange($event, rootGroup.groupId))
                        }, {
                          item: _withCtx(({ element: childGroup }) => [
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                (groupChildren(childGroup.groupId).length)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: _normalizeClass(["icon-btn group-collapse-btn", { collapsed: isGroupCollapsed(childGroup.groupId) }]),
                                      title: isGroupCollapsed(childGroup.groupId) ? 'Untergruppen anzeigen' : 'Untergruppen ausblenden',
                                      "aria-expanded": !isGroupCollapsed(childGroup.groupId),
                                      onClick: ($event: any) => (toggleGroupCollapse(childGroup.groupId))
                                    }, [
                                      _createVNode(_unref(ChevronDownIcon), { size: "16" })
                                    ], 10, _hoisted_68))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_69)),
                                _createElementVNode("div", _hoisted_70, [
                                  _createElementVNode("div", _hoisted_71, _toDisplayString(childGroup.name), 1),
                                  _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("div", _hoisted_73, [
                                      _createVNode(_unref(BookOpenIcon), {
                                        size: "12",
                                        class: "group-member-icon"
                                      }),
                                      _createElementVNode("button", {
                                        class: "count-chip",
                                        onClick: ($event: any) => (openAssignmentsPopup('GROUP', childGroup.groupId, childGroup.name))
                                      }, _toDisplayString(assignmentCountForTarget('GROUP', childGroup.groupId)) + " " + _toDisplayString(assignmentCountForTarget('GROUP', childGroup.groupId) === 1 ? 'Aufgabe' : 'Aufgaben'), 9, _hoisted_74)
                                    ]),
                                    _createElementVNode("div", _hoisted_75, [
                                      _createElementVNode("button", {
                                        class: "count-chip",
                                        onClick: ($event: any) => (openAssignModal(childGroup))
                                      }, _toDisplayString(groupMembers(childGroup.groupId).length) + " Mitarbeiter", 9, _hoisted_76)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_77, [
                                  _createElementVNode("button", {
                                    class: "icon-btn",
                                    title: "Umbenennen",
                                    onClick: ($event: any) => (openEditGroup(childGroup))
                                  }, [
                                    _createVNode(_unref(Edit2Icon), { size: "15" })
                                  ], 8, _hoisted_78),
                                  _createElementVNode("button", {
                                    class: "icon-btn danger",
                                    title: "Löschen",
                                    onClick: ($event: any) => (confirmDeleteGroup(childGroup))
                                  }, [
                                    _createVNode(_unref(TrashIcon), { size: "15" })
                                  ], 8, _hoisted_79)
                                ])
                              ]),
                              ((groupChildren(childGroup.groupId).length && !isGroupCollapsed(childGroup.groupId)) || groupDragActive.value)
                                ? (_openBlock(), _createBlock(_unref(draggable), {
                                    key: 0,
                                    list: groupChildren(childGroup.groupId),
                                    "item-key": "groupId",
                                    group: "org-groups",
                                    class: _normalizeClass(["group-children group-children-l3", { 'group-drop-zone': groupDragActive.value && groupChildren(childGroup.groupId).length === 0 }]),
                                    animation: 160,
                                    "ghost-class": "group-drag-ghost",
                                    filter: "button, a",
                                    "prevent-on-filter": false,
                                    "force-fallback": true,
                                    "fallback-tolerance": 4,
                                    onStart: _cache[2] || (_cache[2] = ($event: any) => (groupDragActive.value = true)),
                                    onEnd: _cache[3] || (_cache[3] = ($event: any) => (groupDragActive.value = false)),
                                    onChange: ($event: any) => (onGroupDragChange($event, childGroup.groupId))
                                  }, {
                                    item: _withCtx(({ element: grandchildGroup }) => [
                                      _createElementVNode("div", _hoisted_80, [
                                        _createElementVNode("div", _hoisted_81, [
                                          _hoisted_82,
                                          _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("div", _hoisted_84, _toDisplayString(grandchildGroup.name), 1),
                                            _createElementVNode("div", _hoisted_85, [
                                              _createElementVNode("div", _hoisted_86, [
                                                _createVNode(_unref(BookOpenIcon), {
                                                  size: "12",
                                                  class: "group-member-icon"
                                                }),
                                                _createElementVNode("button", {
                                                  class: "count-chip",
                                                  onClick: ($event: any) => (openAssignmentsPopup('GROUP', grandchildGroup.groupId, grandchildGroup.name))
                                                }, _toDisplayString(assignmentCountForTarget('GROUP', grandchildGroup.groupId)) + " " + _toDisplayString(assignmentCountForTarget('GROUP', grandchildGroup.groupId) === 1 ? 'Aufgabe' : 'Aufgaben'), 9, _hoisted_87)
                                              ]),
                                              _createElementVNode("div", _hoisted_88, [
                                                _createElementVNode("button", {
                                                  class: "count-chip",
                                                  onClick: ($event: any) => (openAssignModal(grandchildGroup))
                                                }, _toDisplayString(groupMembers(grandchildGroup.groupId).length) + " Mitarbeiter", 9, _hoisted_89)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_90, [
                                            _createElementVNode("button", {
                                              class: "icon-btn",
                                              title: "Umbenennen",
                                              onClick: ($event: any) => (openEditGroup(grandchildGroup))
                                            }, [
                                              _createVNode(_unref(Edit2Icon), { size: "15" })
                                            ], 8, _hoisted_91),
                                            _createElementVNode("button", {
                                              class: "icon-btn danger",
                                              title: "Löschen",
                                              onClick: ($event: any) => (confirmDeleteGroup(grandchildGroup))
                                            }, [
                                              _createVNode(_unref(TrashIcon), { size: "15" })
                                            ], 8, _hoisted_92)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["list", "class", "onChange"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["list", "class", "onChange"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["list"])
            ]),
            (groupModalVisible.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "group-modal-backdrop",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (groupModalVisible.value = false), ["self"]))
                }, [
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, _toDisplayString(groupModalMode.value === 'create' ? (groupModalParentId.value ? 'Untergruppe anlegen' : 'Gruppe anlegen') : 'Gruppe bearbeiten'), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((groupModalName).value = $event)),
                      type: "text",
                      class: "settings-input",
                      placeholder: "Name der Gruppe",
                      onKeyup: _withKeys(saveGroupModal, ["enter"]),
                      autofocus: ""
                    }, null, 40, _hoisted_95), [
                      [_vModelText, groupModalName.value]
                    ]),
                    (groupModalMode.value === 'edit')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_96, [
                          _hoisted_97,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((groupModalWeight).value = $event)),
                            type: "number",
                            class: "settings-input",
                            placeholder: "z. B. 0",
                            onKeyup: _withKeys(saveGroupModal, ["enter"])
                          }, null, 40, _hoisted_98), [
                            [
                              _vModelText,
                              groupModalWeight.value,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _hoisted_99
                        ]))
                      : _createCommentVNode("", true),
                    (groupError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(groupError.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("button", {
                        class: "btn-ghost",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (groupModalVisible.value = false))
                      }, "Abbrechen"),
                      _createElementVNode("button", {
                        class: "btn-primary",
                        disabled: groupModalSaving.value,
                        onClick: saveGroupModal
                      }, _toDisplayString(groupModalSaving.value ? 'Wird gespeichert…' : 'Speichern'), 9, _hoisted_102)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (assignModalVisible.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "group-modal-backdrop",
                  onClick: _withModifiers(closeAssignModal, ["self"])
                }, [
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", null, [
                        _hoisted_106,
                        _createElementVNode("div", _hoisted_107, _toDisplayString(assignModalGroup.value?.name), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "group-modal-close",
                        title: "Schließen",
                        onClick: closeAssignModal
                      }, [
                        _createVNode(_unref(XIcon), { size: "18" })
                      ])
                    ]),
                    _hoisted_108,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((assignSearch).value = $event)),
                      type: "text",
                      class: "settings-input",
                      placeholder: "Mitarbeiter suchen…"
                    }, null, 512), [
                      [_vModelText, assignSearch.value]
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      (assignLoadingMembers.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, "Wird geladen…"))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(assignFilteredUsers), (user) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: user.userId,
                                class: "assign-label"
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: groupAssignPanelMembers.value.includes(user.userId),
                                  onChange: ($event: any) => (toggleGroupMember(user.userId))
                                }, null, 40, _hoisted_111),
                                _createElementVNode("span", _hoisted_112, [
                                  _createElementVNode("span", _hoisted_113, _toDisplayString(displayName(user) || user.email || user.userName), 1),
                                  (displayName(user))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(user.email || user.userName), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128)),
                            (_unref(assignFilteredUsers).length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_115, " Keine Mitarbeiter gefunden. "))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]),
                    _createElementVNode("div", { class: "group-modal-footer" }, [
                      _createElementVNode("button", {
                        class: "btn-primary",
                        onClick: closeAssignModal
                      }, "Fertig")
                    ])
                  ])
                ], 8, _hoisted_103))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'catalog')
        ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
            _hoisted_117,
            (catalogLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_118, " Wird geladen… "))
              : (_openBlock(), _createElementBlock("div", _hoisted_119, [
                  _createElementVNode("table", _hoisted_120, [
                    _hoisted_121,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(catalogCourses), (course) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: course.id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_122, _toDisplayString(course.title), 1),
                            (course.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_123, _toDisplayString(course.description), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (course.category)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_124, _toDisplayString(course.category), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_125, "—"))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(course.duration_minutes ? course.duration_minutes + ' Min.' : '—'), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_126, [
                              (getAssignmentsForCourse(course.id).length > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "count-chip",
                                    onClick: ($event: any) => (openCourseTargetsPopup(course))
                                  }, _toDisplayString(getAssignmentsForCourse(course.id).length) + " zugewiesen", 9, _hoisted_127))
                                : (_openBlock(), _createElementBlock("span", _hoisted_128, "—"))
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_129, [
                            _createElementVNode("button", {
                              class: "btn-ghost small",
                              onClick: ($event: any) => (openCreateAssignment(course))
                            }, [
                              _createVNode(_unref(PlusIcon), { size: "14" }),
                              _createTextVNode(" Zuweisen ")
                            ], 8, _hoisted_130)
                          ])
                        ]))
                      }), 128)),
                      (_unref(catalogCourses).length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_131, _hoisted_133))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
          ]))
        : _createCommentVNode("", true),
      (listPopup.value.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "group-modal-backdrop",
            onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (listPopup.value.visible = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("div", _hoisted_135, _toDisplayString(listPopup.value.title), 1),
              _createElementVNode("ul", _hoisted_136, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listPopup.value.entries, (e, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: i,
                    class: _normalizeClass({ clickable: !!e.onClick }),
                    onClick: ($event: any) => (e.onClick && e.onClick())
                  }, [
                    _createElementVNode("span", _hoisted_138, [
                      _createElementVNode("span", _hoisted_139, _toDisplayString(e.label), 1),
                      (e.sub)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_140, _toDisplayString(e.sub), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (e.action)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn-ghost small lp-action",
                          onClick: _withModifiers(($event: any) => (e.action.onClick()), ["stop"])
                        }, _toDisplayString(e.action.label), 9, _hoisted_141))
                      : _createCommentVNode("", true),
                    (e.onRemove)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "icon-btn danger lp-remove",
                          title: "Entfernen",
                          onClick: _withModifiers(($event: any) => (e.onRemove()), ["stop"])
                        }, [
                          _createVNode(_unref(TrashIcon), { size: "14" })
                        ], 8, _hoisted_142))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_137))
                }), 128)),
                (!listPopup.value.entries.length)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_143, "Keine Einträge."))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_144, [
                (listPopup.value.onAdd)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-ghost",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (listPopup.value.onAdd.action()))
                    }, [
                      _createVNode(_unref(PlusIcon), { size: "14" }),
                      _createTextVNode(" " + _toDisplayString(listPopup.value.onAdd.label), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn-ghost",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (listPopup.value.visible = false))
                }, "Schließen")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (markCompletedModal.value.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: "group-modal-backdrop",
            onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (markCompletedModal.value.visible = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_145, [
              _createElementVNode("div", _hoisted_146, "Als erledigt markieren – " + _toDisplayString(displayName(markCompletedModal.value.user)), 1),
              _createElementVNode("div", _hoisted_147, " Der Kurs „" + _toDisplayString(courseTitle(markCompletedModal.value.courseId)) + "\" wird für diesen Mitarbeiter als abgeschlossen erfasst, z. B. weil die Fortbildung auf einem anderen System absolviert wurde. Der Abschluss erscheint in der Übersicht und auf dem Nachweis und wird als manuell erfasst gespeichert. ", 1),
              _createElementVNode("div", _hoisted_148, [
                _hoisted_149,
                _withDirectives(_createElementVNode("input", {
                  id: "mark-completed-date",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((markCompletedModal.value.date) = $event)),
                  type: "date",
                  class: "settings-input"
                }, null, 512), [
                  [_vModelText, markCompletedModal.value.date]
                ]),
                _hoisted_150
              ]),
              (markCompletedModal.value.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_151, _toDisplayString(markCompletedModal.value.error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_152, [
                _createElementVNode("button", {
                  class: "btn-ghost",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (markCompletedModal.value.visible = false))
                }, "Abbrechen"),
                _createElementVNode("button", {
                  class: "btn-primary",
                  disabled: markCompletedModal.value.saving || !markCompletedModal.value.date,
                  onClick: saveMarkCompleted
                }, _toDisplayString(markCompletedModal.value.saving ? 'Wird gespeichert…' : 'Als erledigt markieren'), 9, _hoisted_153)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (userGroupModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            class: "group-modal-backdrop",
            onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (userGroupModalVisible.value = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_154, [
              _createElementVNode("div", _hoisted_155, "Gruppe zuordnen – " + _toDisplayString(displayName(userGroupModalUser.value)), 1),
              _hoisted_156,
              _createVNode(MultiSelect, {
                "model-value": userGroupMemberships.value[userGroupModalUser.value?.userId] ?? [],
                options: _unref(groupOptions).map(g => ({ value: g.groupId, label: g.label })),
                placeholder: "Gruppen wählen…",
                label: "Gruppen auswählen",
                inline: "",
                "onUpdate:modelValue": onUserGroupsChange
              }, null, 8, ["model-value", "options"]),
              _createElementVNode("div", _hoisted_157, [
                _createElementVNode("button", {
                  class: "btn-primary",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (userGroupModalVisible.value = false))
                }, "Fertig")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (courseAssignModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 6,
            class: "group-modal-backdrop",
            onClick: _cache[35] || (_cache[35] = _withModifiers(($event: any) => (courseAssignModalVisible.value = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("div", _hoisted_159, _toDisplayString(courseAssignModalMode.value === 'create' ? 'Aufgabe zuweisen' : 'Zuweisung bearbeiten'), 1),
              (courseAssignTargetFixed.value && courseAssignModalMode.value === 'create')
                ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                    _hoisted_161,
                    _createElementVNode("div", _hoisted_162, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["toggle-btn", { active: courseAssignForm.value.kind === 'course' }]),
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (courseAssignForm.value.kind = 'course'))
                      }, "Kurs", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["toggle-btn", { active: courseAssignForm.value.kind === 'instruction' }]),
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (courseAssignForm.value.kind = 'instruction'))
                      }, "Unterweisung", 2)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (courseAssignForm.value.kind === 'instruction')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (courseAssignModalMode.value === 'create')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                          _hoisted_164,
                          _createVNode(MultiSelect, {
                            modelValue: courseAssignForm.value.instructionIds,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((courseAssignForm.value.instructionIds) = $event)),
                            options: _unref(allInstructions).map(i => ({ value: i.instructionId, label: i.title })),
                            placeholder: "Unterweisungen wählen…",
                            label: "Unterweisungen auswählen",
                            inline: ""
                          }, null, 8, ["modelValue", "options"]),
                          _createElementVNode("span", _hoisted_165, _toDisplayString(courseAssignForm.value.instructionIds.length === 0
                ? 'Bitte wählen Sie mindestens eine Unterweisung.'
                : courseAssignForm.value.instructionIds.length + ' ausgewählt'), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_166, _toDisplayString(instructionTitle(courseAssignForm.value.instructionId)), 1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (courseAssignModalMode.value === 'create' && !courseAssignModalCourse.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                          _hoisted_168,
                          _createVNode(MultiSelect, {
                            modelValue: courseAssignForm.value.courseIds,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((courseAssignForm.value.courseIds) = $event)),
                            options: _unref(catalogCourses).map(c => ({ value: c.id, label: c.title })),
                            placeholder: "Kurse wählen…",
                            label: "Kurse auswählen",
                            inline: ""
                          }, null, 8, ["modelValue", "options"]),
                          _createElementVNode("span", _hoisted_169, _toDisplayString(courseAssignForm.value.courseIds.length === 0
                ? 'Bitte wählen Sie mindestens einen Kurs.'
                : courseAssignForm.value.courseIds.length + ' ausgewählt'), 1)
                        ]))
                      : (!courseAssignModalCourse.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                            _hoisted_171,
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((courseAssignForm.value.courseId) = $event)),
                              class: "settings-input"
                            }, [
                              _hoisted_172,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(catalogCourses), (c) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: c.id,
                                  value: c.id
                                }, _toDisplayString(c.title), 9, _hoisted_173))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, courseAssignForm.value.courseId]
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_174, _toDisplayString(courseAssignModalCourse.value.title), 1))
                  ], 64)),
              (!courseAssignTargetFixed.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("div", _hoisted_175, [
                      _hoisted_176,
                      _createElementVNode("div", _hoisted_177, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["toggle-btn", { active: courseAssignForm.value.targetType === 'GROUP' }]),
                          onClick: _cache[27] || (_cache[27] = ($event: any) => {courseAssignForm.value.targetType = 'GROUP'; courseAssignForm.value.targetIds = []})
                        }, "Gruppe", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(["toggle-btn", { active: courseAssignForm.value.targetType === 'USER' }]),
                          onClick: _cache[28] || (_cache[28] = ($event: any) => {courseAssignForm.value.targetType = 'USER'; courseAssignForm.value.targetIds = []})
                        }, "Mitarbeiter:in", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_178, [
                      _createElementVNode("label", _hoisted_179, [
                        _createTextVNode(_toDisplayString(courseAssignForm.value.targetType === 'GROUP' ? 'Gruppen' : 'Personen') + " ", 1),
                        _hoisted_180
                      ]),
                      _createVNode(MultiSelect, {
                        modelValue: courseAssignForm.value.targetIds,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((courseAssignForm.value.targetIds) = $event)),
                        options: courseAssignForm.value.targetType === 'GROUP'
                ? _unref(groupOptions).map(g => ({ value: g.groupId, label: g.label }))
                : _unref(users).map(u => ({ value: u.userId, label: displayName(u) || u.email || u.userName })),
                        placeholder: courseAssignForm.value.targetType === 'GROUP' ? 'Gruppen wählen…' : 'Personen wählen…',
                        label: courseAssignForm.value.targetType === 'GROUP' ? 'Gruppen auswählen' : 'Personen auswählen',
                        inline: ""
                      }, null, 8, ["modelValue", "options", "placeholder", "label"]),
                      _createElementVNode("span", _hoisted_181, _toDisplayString(courseAssignForm.value.targetIds.length === 0
                ? 'Bitte wählen Sie mindestens einen Eintrag.'
                : courseAssignForm.value.targetIds.length + ' ausgewählt'), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_182, [
                _hoisted_183,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((courseAssignForm.value.deadline) = $event)),
                  type: "date",
                  class: "settings-input"
                }, null, 512), [
                  [_vModelText, courseAssignForm.value.deadline]
                ])
              ]),
              _createElementVNode("div", _hoisted_184, [
                _hoisted_185,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((courseAssignForm.value.recurAnnually) = $event)),
                  type: "checkbox",
                  class: "toggle-checkbox"
                }, null, 512), [
                  [_vModelCheckbox, courseAssignForm.value.recurAnnually]
                ])
              ]),
              _createElementVNode("div", _hoisted_186, [
                _hoisted_187,
                _createElementVNode("div", _hoisted_188, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((courseAssignForm.value.notifyDaysBefore) = $event)),
                    type: "number",
                    min: "0",
                    max: "365",
                    class: "settings-input notify-days-input",
                    placeholder: "z. B. 30"
                  }, null, 512), [
                    [
                      _vModelText,
                      courseAssignForm.value.notifyDaysBefore,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _hoisted_189
                ]),
                _hoisted_190
              ]),
              _createElementVNode("div", _hoisted_191, [
                _hoisted_192,
                _createElementVNode("div", _hoisted_193, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((courseAssignForm.value.notifyCount) = $event)),
                    type: "number",
                    min: "0",
                    max: "10",
                    class: "settings-input notify-count-input",
                    placeholder: "z. B. 3"
                  }, null, 512), [
                    [
                      _vModelText,
                      courseAssignForm.value.notifyCount,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _hoisted_194
              ]),
              (courseAssignError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_195, _toDisplayString(courseAssignError.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_196, [
                (courseAssignModalMode.value === 'edit')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-danger",
                      onClick: doDeleteAssignment
                    }, "Löschen"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn-ghost",
                  onClick: _cache[34] || (_cache[34] = ($event: any) => (courseAssignModalVisible.value = false))
                }, "Abbrechen"),
                _createElementVNode("button", {
                  class: "btn-primary",
                  disabled: courseAssignSaving.value || (courseAssignModalMode.value === 'create'
              ? (!courseAssignForm.value.targetIds.length || (courseAssignForm.value.kind === 'instruction' ? !courseAssignForm.value.instructionIds.length : (!courseAssignModalCourse.value && !courseAssignForm.value.courseIds.length)))
              : (!courseAssignForm.value.targetId || (courseAssignForm.value.kind === 'instruction' ? !courseAssignForm.value.instructionId : (!courseAssignModalCourse.value && !courseAssignForm.value.courseId)))),
                  onClick: saveAssignment
                }, _toDisplayString(courseAssignSaving.value ? 'Wird gespeichert…' : 'Speichern'), 9, _hoisted_197)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'instructions')
        ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
            _createVNode(InstructionAdmin, { onAssign: openCreateAssignmentForInstruction })
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'courses')
        ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
            _createElementVNode("div", _hoisted_200, [
              _hoisted_201,
              _createElementVNode("div", _hoisted_202, [
                _withDirectives(_createElementVNode("select", {
                  class: "year-select",
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((selectYear).value = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(courseYears), (year) => {
                    return (_openBlock(), _createElementBlock("option", { key: year }, _toDisplayString(year), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, selectYear.value]
                ]),
                _createElementVNode("button", {
                  class: "btn-ghost",
                  onClick: _cache[37] || (_cache[37] = ($event: any) => (printOrgOverviewAll()))
                }, " Gesamtübersicht ")
              ])
            ]),
            _createElementVNode("div", _hoisted_203, [
              _createElementVNode("table", _hoisted_204, [
                _hoisted_205,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(users), (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.userId
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_206, _toDisplayString(displayName(user) || user.userName), 1),
                        _createElementVNode("div", _hoisted_207, _toDisplayString(user.email || user.userName), 1)
                      ]),
                      _createElementVNode("td", null, [
                        (completedCoursesForUser(user.userId).length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "count-chip",
                              onClick: ($event: any) => (openCompletionsPopup(user, completedCoursesForUser(user.userId), 'Kurse'))
                            }, _toDisplayString(completedCoursesForUser(user.userId).length) + " abgeschlossen", 9, _hoisted_208))
                          : (_openBlock(), _createElementBlock("span", _hoisted_209, "—"))
                      ]),
                      _createElementVNode("td", null, [
                        (completedInstructionsForUser(user.userId).length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "count-chip",
                              onClick: ($event: any) => (openCompletionsPopup(user, completedInstructionsForUser(user.userId), 'Unterweisungen'))
                            }, _toDisplayString(completedInstructionsForUser(user.userId).length) + " abgeschlossen", 9, _hoisted_210))
                          : (_openBlock(), _createElementBlock("span", _hoisted_211, "—"))
                      ]),
                      _createElementVNode("td", _hoisted_212, [
                        _createElementVNode("button", {
                          class: "btn-ghost small",
                          disabled: !userHasAnyCompletion(user.userId),
                          onClick: ($event: any) => (printUserCombined(user))
                        }, "Sammel-Zertifikat", 8, _hoisted_213)
                      ])
                    ]))
                  }), 128)),
                  (_unref(users).length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_214, _hoisted_216))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'reminders')
        ? (_openBlock(), _createElementBlock("div", _hoisted_217, [
            _createElementVNode("div", _hoisted_218, [
              _hoisted_219,
              _createElementVNode("div", _hoisted_220, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((reminderSearch).value = $event)),
                  type: "search",
                  class: "reminder-search",
                  placeholder: "Empfänger oder Kurs suchen"
                }, null, 512), [
                  [_vModelText, reminderSearch.value]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "year-select",
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((reminderStatusFilter).value = $event))
                }, _hoisted_225, 512), [
                  [_vModelSelect, reminderStatusFilter.value]
                ])
              ])
            ]),
            _hoisted_226,
            _createElementVNode("div", _hoisted_227, [
              _createElementVNode("table", _hoisted_228, [
                _hoisted_229,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredReminderLogs), (r) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: r.reminderId
                    }, [
                      _createElementVNode("td", null, _toDisplayString(fmtDateTime(r.sentAt)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_230, _toDisplayString(r.userName || r.email), 1),
                        _createElementVNode("div", _hoisted_231, _toDisplayString(r.email), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(reminderKindLabel(r.kind)), 1),
                      _createElementVNode("td", null, _toDisplayString(r.itemTitle), 1),
                      _createElementVNode("td", null, _toDisplayString(fmtIsoDate(r.deadline)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", reminderBadgeClass(r.status)])
                        }, _toDisplayString(reminderStatusLabel(r.status)), 3)
                      ])
                    ]))
                  }), 128)),
                  (_unref(reminderLogsLoading) && _unref(filteredReminderLogs).length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_232, _hoisted_234))
                    : (_unref(filteredReminderLogs).length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_235, _hoisted_237))
                      : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'settings')
        ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
            _createElementVNode("form", {
              class: "settings-form",
              onSubmit: _withModifiers(saveSettings, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_240, [
                _createElementVNode("div", _hoisted_241, [
                  _hoisted_242,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((settingsForm.value.name) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "Name der Einrichtung",
                    required: ""
                  }, null, 512), [
                    [_vModelText, settingsForm.value.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_243, [
                  _hoisted_244,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((settingsForm.value.street) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "Musterstraße"
                  }, null, 512), [
                    [_vModelText, settingsForm.value.street]
                  ])
                ]),
                _createElementVNode("div", _hoisted_245, [
                  _hoisted_246,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((settingsForm.value.streetNo) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "12"
                  }, null, 512), [
                    [_vModelText, settingsForm.value.streetNo]
                  ])
                ]),
                _createElementVNode("div", _hoisted_247, [
                  _hoisted_248,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((settingsForm.value.addressAddition) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "optional"
                  }, null, 512), [
                    [_vModelText, settingsForm.value.addressAddition]
                  ])
                ]),
                _createElementVNode("div", _hoisted_249, [
                  _hoisted_250,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((settingsForm.value.postalCode) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "12345"
                  }, null, 512), [
                    [_vModelText, settingsForm.value.postalCode]
                  ])
                ]),
                _createElementVNode("div", _hoisted_251, [
                  _hoisted_252,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((settingsForm.value.city) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "Musterstadt"
                  }, null, 512), [
                    [_vModelText, settingsForm.value.city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_253, [
                  _hoisted_254,
                  _createElementVNode("div", _hoisted_255, [
                    _createElementVNode("div", _hoisted_256, [
                      (logoPreview.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: logoPreview.value,
                            class: "logo-preview",
                            alt: "Logo"
                          }, null, 8, _hoisted_257))
                        : (_openBlock(), _createElementBlock("div", _hoisted_258, _hoisted_261))
                    ]),
                    _createElementVNode("div", _hoisted_262, [
                      _hoisted_263,
                      _createElementVNode("label", {
                        class: _normalizeClass(["btn-ghost logo-upload-btn", { uploading: logoUploading.value }])
                      }, [
                        _createTextVNode(_toDisplayString(logoUploading.value ? 'Wird hochgeladen…' : 'Logo auswählen') + " ", 1),
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/png,image/jpeg,image/svg+xml",
                          class: "sr-only",
                          disabled: logoUploading.value,
                          onChange: handleLogoUpload
                        }, null, 40, _hoisted_264)
                      ], 2),
                      (logoError.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_265, _toDisplayString(logoError.value), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_266, [
                (settingsSaved.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_267, "Gespeichert"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn-ghost",
                  disabled: settingsSaving.value
                }, _toDisplayString(settingsSaving.value ? 'Wird gespeichert…' : 'Speichern'), 9, _hoisted_268)
              ])
            ], 40, _hoisted_239)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(InviteUser, {
      groups: groups.value,
      onUserCreated: onUserCreated
    }, null, 8, ["groups"]),
    _createVNode(DeleteUser, { userId: selectedUserUserId.value }, null, 8, ["userId"]),
    (editUserModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "group-modal-backdrop",
          onClick: _cache[52] || (_cache[52] = _withModifiers(($event: any) => (editUserModalVisible.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_269, [
            _createElementVNode("div", _hoisted_270, [
              _hoisted_271,
              _createElementVNode("button", {
                class: "group-modal-close",
                type: "button",
                "aria-label": "Schließen",
                onClick: _cache[46] || (_cache[46] = ($event: any) => (editUserModalVisible.value = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_272, [
              _createElementVNode("div", _hoisted_273, [
                _hoisted_274,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((editUserForm.value.firstName) = $event)),
                  type: "text",
                  class: "settings-input",
                  placeholder: "Vorname",
                  onKeyup: _withKeys(saveEditUser, ["enter"]),
                  autofocus: ""
                }, null, 40, _hoisted_275), [
                  [_vModelText, editUserForm.value.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_276, [
                _hoisted_277,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((editUserForm.value.lastName) = $event)),
                  type: "text",
                  class: "settings-input",
                  placeholder: "Nachname",
                  onKeyup: _withKeys(saveEditUser, ["enter"])
                }, null, 40, _hoisted_278), [
                  [_vModelText, editUserForm.value.lastName]
                ])
              ]),
              _createElementVNode("div", _hoisted_279, [
                _hoisted_280,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((editUserForm.value.email) = $event)),
                  type: "email",
                  autocomplete: "off",
                  class: "settings-input",
                  placeholder: "name@einrichtung.de",
                  onKeyup: _withKeys(saveEditUser, ["enter"])
                }, null, 40, _hoisted_281), [
                  [_vModelText, editUserForm.value.email]
                ]),
                _hoisted_282
              ]),
              (editUserTarget.value?.type !== 'OWNER')
                ? (_openBlock(), _createElementBlock("div", _hoisted_283, [
                    _createElementVNode("label", _hoisted_284, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((editUserForm.value.isAdmin) = $event)),
                        class: "edit-admin-check"
                      }, null, 512), [
                        [_vModelCheckbox, editUserForm.value.isAdmin]
                      ]),
                      _hoisted_285
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (editUserError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_286, _toDisplayString(editUserError.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_287, [
              _createElementVNode("button", {
                class: "btn-ghost",
                onClick: _cache[51] || (_cache[51] = ($event: any) => (editUserModalVisible.value = false))
              }, "Abbrechen"),
              _createElementVNode("button", {
                class: "btn-primary",
                disabled: editUserSaving.value,
                onClick: saveEditUser
              }, _toDisplayString(editUserSaving.value ? 'Wird gespeichert…' : 'Speichern'), 9, _hoisted_288)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (removeGroupConfirm.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "group-modal-backdrop",
          onClick: _cache[54] || (_cache[54] = _withModifiers(($event: any) => (removeGroupConfirm.value = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_289, [
            _hoisted_290,
            _createElementVNode("p", _hoisted_291, [
              _createTextVNode(" Soll der Mitarbeiter wirklich aus der Gruppe "),
              _createElementVNode("strong", null, _toDisplayString(groups.value.find(g => g.groupId === removeGroupConfirm.value?.groupId)?.name), 1),
              _createTextVNode(" entfernt werden? ")
            ]),
            _createElementVNode("div", _hoisted_292, [
              _createElementVNode("button", {
                class: "btn-ghost",
                onClick: _cache[53] || (_cache[53] = ($event: any) => (removeGroupConfirm.value = null))
              }, "Abbrechen"),
              _createElementVNode("button", {
                class: "btn-danger",
                onClick: confirmRemoveFromGroup
              }, "Entfernen")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})